<template>
  <div id="termsOfService" style="background-color: #eff3f5;height: 100%;width: 100%;overflow: scroll" align="center" overflow="scroll">
    <a-card style="background-color: white;width: 1100px;margin-top: 50px;padding-left: 20px;padding-right: 20px">
      <div style="margin-top: 20px">
        <h3>
          <p style="font-size: 26px">SUNTONE TECHNOLOGY CO., LIMITED条款及细则</p>
        </h3>
      </div>
      <div align="left" style="margin-top: 50px">
        <p>这些使用条款<strong><strong>，</strong></strong>包括附录，指导您使用SUNTONE TECHNOLOGY CO., LIMITED提供的服务。请仔细阅读这些本条款及细则，因为它们构成了您和我们之间的法律关系。</p>
<p>&nbsp;</p>
<p>本条款及细则包括本页面和以下内容：</p>
<ol>
<li>本文件</li>
<li>关于我们</li>
<li>本条款及细则的变更</li>
<li>身份检查和信息要求</li>
<li>关于我们的服务</li>
<li>入门指引</li>
<li>授权用户</li>
<li>收款服务</li>
<li>外汇兑换服务</li>
<li>付款服务</li>
<li>撤消和拒绝</li>
<li>安全和保障</li>
<li>费用和收费</li>
<li>知识产权</li>
<li>数据的保密、隐私和使用</li>
<li>披露信息和使用个人数据进行直接营销</li>
<li>责任限制</li>
<li>赔偿</li>
<li>协议终止和中止</li>
<li>第三方服务供应商</li>
<li>声明与保证</li>
<li>市场动荡、错误和不可抗力</li>
<li>一般条款</li>
<li>定义和解释</li>
</ol>
<p>&nbsp;</p>
<p>除了本条款及细则外，以下附加文件也适用于您使用支付平台和服务，并应与本条款及细则一起阅读：</p>
<p>-条款及细则补充协议</p>
<p>-可接受的使用政策</p>
<p>&nbsp;</p>
<p>本使用条款和附加文件可不时补充或修改，我们将根据适用法律和本条款及细则提前通知您。您可以在我们的www.sprout-pay.com网站（&ldquo;网站&rdquo;）上看到这些文件的最新版本。我们建议您通过打印或下载的方式保存本使用条款的副本，以供今后参考。</p>
<p>&nbsp;</p>
<p>通过在我们的网站注册使用我们的任何服务，您同意受本条款及细则的约束（可能不时补充或修改），这些条款可通过我们的网站在线提供给您。通过单击按钮&ldquo;创建帐户&rdquo;或类似按钮，注册、访问或使用服务（统称为&ldquo;默示同意&rdquo;），您将与UNTONE TECHNOLOGY CO., LIMITED订立具有法律约束力的协议，并同意接受本条款及细则。如果您不接受本条款及细则（或对本条款及细则的任何补充或修改），请不要使用我们的任何服务。</p>
<p>&nbsp;</p>
<p>如果在给予您的默示同意后，您和UNTONE TECHNOLOGY CO., LIMITED同意执行本条款及细则的纸质版本，本条款及细则的纸质版本也将是有效的，并在您第一次给予您的默示同意之日起追溯生效。若线上版本和纸质版本之间存在不一致，以线上版本为准。</p>
<p>&nbsp;</p>
<p><strong><strong>最后更新：202</strong></strong><strong><strong>4</strong></strong><strong><strong>年</strong></strong><strong><strong>6</strong></strong><strong><strong>月</strong></strong></p>
<p>&nbsp;</p>
<p><strong><strong>1.本</strong></strong><strong><strong>文件</strong></strong></p>
<p><strong><strong>1.1 各方</strong></strong></p>
<p>在使用UNTONE TECHNOLOGY CO., LIMITED平台和服务时，您（&ldquo;客户&rdquo;/&ldquo;您&rdquo;/&ldquo;您的&rdquo;）同意这些适用于您和UNTONE TECHNOLOGY CO., LIMITED（&ldquo;UNTONE TECHNOLOGY CO., LIMITED&rdquo;/&ldquo;我们&rdquo;/&ldquo;我们的&rdquo;）之间的本条款及细则。请仔细阅读这些条款及细则，如有任何不清楚的地方，请联系我们。</p>
<p>附加文件 以下附加文件（不时更新）也适用于您对UNTONE TECHNOLOGY CO., LIMITED平台和服务的使用，并应与本条款及细则一起阅读。</p>
<p>(a)可接受的使用政策</p>
<p>(b)隐私政策</p>
<p>(c)产品协议</p>
<p>当我们向您提供其他服务时，您应参考这些其他服务的条款和条件。</p>
<p><strong><strong>1.</strong></strong><strong><strong>2</strong></strong><strong><strong>&nbsp;联系我们</strong></strong></p>
<p>如果我们需要以您可以保存的形式向您发送信息，我们会向您发送电子邮件，或在我们的网站上提供信息，或通过您可以下载的UNTONE TECHNOLOGY CO., LIMITED平台。请保留我们发送给您的所有通信的副本。</p>
<p>&nbsp;</p>
<p><strong><strong>2.关于我们</strong></strong></p>
<p><strong><strong>2.1公司信息</strong></strong><strong><strong><br /></strong></strong>本服务由根据香港法律注册成立的UNTONE TECHNOLOGY CO., LIMITED提供。UNTONE TECHNOLOGY CO., LIMITED已获香港海关根据《打击洗钱及恐怖分子资金筹集条例》授权提供汇款服务和货币兑换服务。除非在区域特别条款中另有约定，UNTONE TECHNOLOGY CO., LIMITED将直接或间接通过其或其关联公司，为您提供本使用条款项下的服务。UNTONE TECHNOLOGY CO., LIMITED与其的关联公司一起，将提供专业的支付平台的营运，该平台可以自动完成从收款到资金处理（货币兑换，结算和下发）的整个支付周期。 UNTONE TECHNOLOGY CO., LIMITED将直接或通过其关联公司或服务提供商向您提供服务。</p>
<p><strong><strong>2.2联系</strong></strong><strong><strong>我们</strong></strong></p>
<p>您可以通过以下方式联系我们：</p>
<ul>
<li>发送电子邮件至：cs@sprout-pay.com；</li>
<li>通过我们网站上的联系链接给我们发信息。</li>
</ul>
<p><strong><strong>2.3</strong></strong><strong><strong>通讯</strong></strong></p>
<p>在适用法律允许的最大限度内，本使用条款（包括任何修改和补充）、通知或我们向您发出的、与我们的服务有关的其他信息（&ldquo;通信&rdquo;）将以电子形式提供给您，您同意以电子形式接收通信。电子通讯会公示在我们网站内的网页上（包括只有在您通过支付平台登录到您的全球账户后，才能访问的通讯）和/或发送到您在我们网站注册的电子邮件地址。除以电子方式沟通外，我们可酌情通过信件、电话、短信或手机与您联系。如果怀疑或实际存在欺诈或安全威胁，我们将使用SMS，电子邮件或其他安全程序与您联系。所有电子通信将被视为&ldquo;书面&rdquo;。您同意以电子方式接收通信是有效的，直到您通过通知我们撤销您的同意。如果您撤销您对以电子方式接收通信的同意，我们可以终止您使用支付平台和服务的权利，并且您在适用法律允许的范围内对因暂停或终止服务而造成的任何后果承担唯一责任。您应该定期和经常检查您在我们网站注册的电子邮件账户的适当功能。我们通过支付平台向您提供与我们的服务相关的信息，我们将在本平台上让您知道相关信息将保留多久。在合理认为与您联系是非法的或是损害我们的合理的安全措施的情况下，我们将通过电话、电子邮件或两者同时与您联系(除非联系您是非法的或危及我们的合理安全措施)。</p>
<p>&nbsp;</p>
<p><strong><strong>3.本</strong></strong><strong><strong>文件</strong></strong><strong><strong>的变更</strong></strong></p>
<p><strong><strong>3.1一般性变更</strong></strong></p>
<p>我们有权通过提前一（1）个月向您发出书面通知来更改这些条款。如果您在通知期内未向我们发出书面通知终止本条款及细则，则视为您已接受拟议的变更。</p>
<p><strong><strong>3.2紧急变更</strong></strong></p>
<p>我们也可能会在不事先通知的情况下立即做出一些更改，如果它们：</p>
<ul>
<li>适用法律所要求的；</li>
<li>这些条款与我们的服务中增加的新服务或额外功能有关，不影响与现有服务有关的任何条款。</li>
</ul>
<p><strong><strong>3.3如果您不同意变更</strong></strong></p>
<p>如果您不同意任何变更，您应该停止使用我们的相应服务。如果您在我们宣布变更后继续使用我们的相应服务，则视为您已接受该变更。</p>
<p><strong><strong>3.4修改</strong></strong></p>
<p>我们可能会在任何时候修改UNTONE TECHNOLOGY CO., LIMITED平台的配置、外观或功能，以方便UNTONE TECHNOLOGY CO., LIMITED平台的持续和正常运作或遵守适用法律。如果修改会对您使用UNTONE TECHNOLOGY CO., LIMITED平台的能力产生重大影响， UNTONE TECHNOLOGY CO., LIMITED将在合理可行的范围内至少提前一周向您发出关于该变更的通知。</p>
<p><strong><strong>3.5更新</strong></strong></p>
<p>我们可能会不时发布UNTONE TECHNOLOGY CO., LIMITED平台，包括UNTONE TECHNOLOGY CO., LIMITED&nbsp;APIs的更新。有些更新可能需要您采取措施来实施。在某些情况下（例如，如果存在安全风险），您将无法使用UNTONE TECHNOLOGY CO., LIMITED平台，直到您实施更新。如果您在我们发布更新后6个月内仍未实施更新，我们有权提前两个月以书面形式通知您，停止向您提供部分服务或终止本条款及细则。</p>
<p>&nbsp;</p>
<p><strong><strong>4.身份检查和信息要求</strong></strong></p>
<p><strong><strong>4.1身份检查</strong></strong></p>
<p>根据适用法律并在合法范围内，在我们向您提供服务之前和期间，我们将不时对您、您的董事、合伙人、最终实际所有人和雇员（如相关）以及您交易中涉及的任何各方进行客户尽职调查。为了能够使用我们的服务，您必须首先向我们申请注册，并通过支付平台在线完成我们了解您的客户/客户尽职调查(&ldquo;KYC/CDD&rdquo;)过程。在您完成了令我们满意的KYC/CDD过程后，将根据您提供的信息创建用户配置文件。</p>
<p><strong><strong>4.2信息请求</strong></strong></p>
<p>您将在任何时候及时提供我们所需的任何额外信息，除有合理原因外最迟在我们提出要求后2个工作日内提供。例如，我们可能要求提供信息以确认某些交易的真实性。根据您注册的服务类型，您可能会被要求提供额外的信息或文件，或接受涵盖此类服务的额外或补充条款和条件。如果您的业务活动、所有权和管理结构、联系信息或与您的用户配置文件有关的其他信息有任何变化，您必须通过支付平台及时更新任何此类更改。您需要保证您的用户配置文件上记录的信息是完整的、准确的和最新的。我们可能要求您确认和/或提供证据或证明（包括经认证或公证的副本），以确保您信息的准确性。您同意立即遵守我们为满足我们的业务和法律要求而提出的所有信息请求，以执行与您有关的KYC/CDD（包括提供关于您的董事和受益所有人的个人信息）。您保证所提供的任何资料均应真实、准确和合法地向我们披露。</p>
<p><strong><strong>4.3第三方验证</strong></strong></p>
<p>您同意，我们可以向您或第三方提出我们认为适当的查询，以评估您的信誉，防止欺诈和滥用银行系统，并履行我们的法定和监管义务，您授权我们进行此类查询。如果提供了虚假或不准确的信息，或者我们怀疑有任何可疑活动或非法活动，例如欺诈，或者如果发现欺诈，我们将予以记录，并向警方、包括欺诈预防机构在内的任何监管机构等执法机构提交相关报告，或在必要时采取其他行动。执法机构或其他相关部门可以访问和使用您提供给我们的任何信息。</p>
<p><strong><strong>4.4信用评估</strong></strong></p>
<p>您同意我们提供服务以及您使用服务的能力受制于：</p>
<ul>
<li>顺利完成初步和任何后续的信用评估；</li>
<li>在本条款及细则的有效期内，您的信用状况没有重大恶化。</li>
</ul>
<p><strong><strong>4.5独立行事</strong></strong></p>
<p>您确认您是以自己的名义行事，而不是代表任何其他人或法律实体。如果您是作为信托的受托人订立这些条款，您必须向我们披露。我们将认为阁下对UNTONE TECHNOLOGY CO., LIMITED帐户及关联帐户的任何使用，包括进出该等帐户的任何转账，均为阁下所为。</p>
<p><strong><strong>5.关于我们的服务</strong></strong></p>
<p><strong><strong>5.1 </strong></strong><strong><strong>UNTONE TECHNOLOGY CO., LIMITED</strong></strong><strong><strong>账户和平台</strong></strong></p>
<p>一旦您成功向我们注册，我们将为您建立一个UNTONE TECHNOLOGY CO., LIMITED账户。除非我们同意，否则您只能拥有一个UNTONE TECHNOLOGY CO., LIMITED账户。如果我们发现您有多于一个UNTONE TECHNOLOGY CO., LIMITED账户，并且我们合理地相信您建立这些UNTONE TECHNOLOGY CO., LIMITED账户是为了绕过服务中的任何限制，我们可决定合并或关闭任何重复的资料，或终止对您的服务，但在终止前我们会给你发出书面通知并邀请您阐释您的原因。您可以使用您的UNTONE TECHNOLOGY CO., LIMITED账户登录并进入UNTONE TECHNOLOGY CO., LIMITED平台。UNTONE TECHNOLOGY CO., LIMITED平台将确保为您提供一个用来访问和使用我们的各种服务的易于使用的用户界面。您的账户将用于从我们处收取结算资金，且有可能是SWIFT网络的一部分。我们不对第三方引起的任何迟延收款或客户账户分录中的错误承担任何责任，包括但不限于因服务提供商或您的银行造成的延迟或错误。</p>
<p><strong><strong>5.2服务概述</strong></strong></p>
<p>我们根据这本条款及细则提供的服务包括：</p>
<ul>
<li>收款服务&mdash;&mdash;UNTONE TECHNOLOGY CO., LIMITED为您以支持币种收取资金。</li>
<li>付款服务&mdash;&mdash;您可以向收款人发送付款；</li>
<li>外汇兑换服务&mdash;&mdash;您可以将资金从一种支持币种兑换成另一种支持币种。</li>
</ul>
<p>每项服务都是由UNTONE TECHNOLOGY CO., LIMITED提供的独立服务。</p>
<p>作为收款、付款或外汇兑换服务的条件，UNTONE TECHNOLOGY CO., LIMITED将自行决定已经收到的文件或其他信息在形式和内容上是否充足。</p>
<p><strong><strong>5.3收款服务</strong></strong></p>
<p>就收款服务而言，我们将向您提供支持币种的当地银行账户凭证，您可向您的付款人提供该凭证，以便向您汇款。所收取的资金将以每一种支持币种记录在我们为您设立的全球账户中。您可以在任何时候向UNTONE TECHNOLOGY CO., LIMITED发出相关提款指令，将资金提取到您自己的同名账户。为您收取的资金在全球账户中的停留时间不得超过第8.4条规定的最长期限。</p>
<p><strong><strong>5.4付款服务和外汇兑换</strong></strong></p>
<p>UNTONE TECHNOLOGY CO., LIMITED允许客户向收款人进行单笔或多笔付款。在付款服务和/或外汇兑换服务方面，UNTONE TECHNOLOGY CO., LIMITED将设立一个备付金银行账户，您可以向该账户汇款，以支付您的付款和/或外汇兑换指令。UNTONE TECHNOLOGY CO., LIMITED将根据您在向备付金银行账户汇款时给我们的具体指令，将这些资金以支持货币汇给您指定的收款人，和/或将这些资金从源货币转换为买入货币。</p>
<p><strong><strong>5.5交易记录</strong></strong></p>
<p>您的交易记录将记录在UNTONE TECHNOLOGY CO., LIMITED账户中，该资料将显示通过全球账户收取的资金（作为收款服务的一部分）以及支付到备付金银行账户的资金（作为付款服务和您的外汇兑换的一部分）。</p>
<p><strong><strong>5.6存款保障计划</strong></strong></p>
<p>香港存款保障计划（"存保计划"）不适用于与我们服务有关的资金发送、交换或接收。您明白并同意，我们不是银行，也不向您提供香港存款保障计划下适用的银行账户，因此我们的服务不受存保计划的保障。您进一步同意，全球账户是一个&ldquo;虚拟账户&rdquo;，而不是一个银行账户，转移给我们的资金的受益人是我们，不会为您信托，您不会赚取利息或有权获得任何资金的利息。</p>
<p><strong><strong>5.7保证您的资金安全</strong></strong></p>
<p>为了保证您的资金安全，UNTONE TECHNOLOGY CO., LIMITED已经采取了商业上合理的管理和技术措施，以保护和保障为您收取或从您那里收到的与服务有关的资金。UNTONE TECHNOLOGY CO., LIMITED将把该等资金存放在指定的银行账户中，与UNTONE TECHNOLOGY CO., LIMITED的公司资金分开，并且不会将该等资金用于自身的运营开支。</p>
<p><strong><strong>5.8限制</strong></strong></p>
<p>我们可能会根据某些监管要求、您的居住国、身份验证检查或业务要求，对服务的全部或任何部分的使用进行临时或永久限制，所有这些都已在可接受使用政策或任何附加条款中规定。这些限制将在实施时告知您，如果由于紧急或不可预见的情况而无法实施，则将在实施限制后立即通知您。</p>
<p><strong><strong>5.9您与我们的关系</strong></strong></p>
<p>根据本条款及细则，我们是您的服务提供商。除非另有明文规定，UNTONE TECHNOLOGY CO., LIMITED不会为阁下或阁下的付款人/收款人担任受托人、托管代理人或持份者。UNTONE TECHNOLOGY CO., LIMITED对阁下的任何产品、服务或业务的任何其他部分概不负责。</p>
<p><strong><strong>5.10服务保证金</strong></strong></p>
<p>您须就任何UNTONE TECHNOLOGY CO., LIMITED所提供的服务，例如付款服务和/或外汇兑换服务，按我们不时要求的金额向我们支付合理保证金。为免生疑问，本公司有权要求您在该等服务的最终结算前随时支付额外的金额以增加保证金的金额，以确保在结算您向我们提供的保证金期间，扣除您可能产生的任何适用费用（如银行间费用、UNTONE TECHNOLOGY CO., LIMITED的代理银行费用及/或其他处理费用）后，仍有足够的金额继续为您提供服务。</p>
<p><strong><strong>5.11选定服务</strong></strong></p>
<ul>
<li>客户在订购期内订购服务。</li>
<li>UNTONE TECHNOLOGY CO., LIMITED应根据本协议及本服务附表提供上述服务。每项订购的服务的订购期（如适用）应自动续订12个月，除非客户在订购期结束前30天向UNTONE TECHNOLOGY CO., LIMITED发出书面通知，明确说明客户不愿意续订。</li>
</ul>
<p><strong><strong>5.12工作时间</strong></strong></p>
<p>UNTONE TECHNOLOGY CO., LIMITED的工作时间：北京时间每个工作日上午9:30至12:00，下午13:00至16:00，但不包括中国大陆、香港和/或任何其他由UNTONE TECHNOLOGY CO., LIMITED或其第三方供应商经营的司法管辖区的节假日。</p>
<p>&nbsp;</p>
<p><strong><strong>6.入门指引</strong></strong></p>
<p><strong><strong>6.1创建您的账户</strong></strong></p>
<p>为了使用我们的服务，您必须根据UNTONE TECHNOLOGY CO., LIMITED平台的提示提供必要的信息，以注册和创建您的UNTONE TECHNOLOGY CO., LIMITED账户。如果UNTONE TECHNOLOGY CO., LIMITED要求，您必须提供您的银行账户信息，以便与您的UNTONE TECHNOLOGY CO., LIMITED账户绑定。</p>
<p><strong><strong>6.2开设全球账户</strong></strong></p>
<p>当我们建立了您的UNTONE TECHNOLOGY CO., LIMITED账户后，您可以登入UNTONE TECHNOLOGY CO., LIMITED的平台，并提供必要的信息，包括我们可能不时要求的任何额外数据，以提交开设全球账户的要求。您还需要同意相应的附加条款。前述文件或者条款我们均会在您申请开立全球账户时或之前告知您相关要求。</p>
<p><strong><strong>6.3设置API</strong></strong></p>
<p>您可以通过UNTONE TECHNOLOGY CO., LIMITED的API和商户服务平台访问UNTONE TECHNOLOGY CO., LIMITED平台。但要通过UNTONE TECHNOLOGY CO., LIMITEDAPI使用我们的服务，您必须先获得我们的批准。如果您获得我们的批准，您将需要遵守我们的API文件以及有关整合和使用UNTONE TECHNOLOGY CO., LIMITEDAPI的任何合理指示。</p>
<p><strong><strong>6.4信息验证和测试</strong></strong></p>
<p>只有当我们对您提供的信息以及我们不时合理要求的任何后续信息感到满意，并且我们能够核实这些信息并使我们感到满意时，我们才会创建您的UNTONE TECHNOLOGY CO., LIMITED账户并允许您使用我们的服务。在我们接受您为客户之前，我们可能会为您建立一个全球账户，并提供您进入UNTONE TECHNOLOGY CO., LIMITED平台的方式（不论是通过UNTONE TECHNOLOGY CO., LIMITEDAPI或商户服务平台）进行测试。此外，我们可能会要求您向全球账户传输少量资金以进行测试或验证。为免生疑问，除非且直至我们确认您已被接纳为我们的客户，否则您不会被视为我们的客户，您亦不能使用我们的任何服务，而如果我们不接纳您为客户，您为测试或验证目的而向我们提供的任何款项将全数退还给您。</p>
<p>&nbsp;</p>
<p><strong><strong>7.授权用户</strong></strong></p>
<p><strong><strong>7.1授权用户</strong></strong></p>
<p>您可委任授权用户代表您根据本条款及细则订立及确认外汇兑换及付款。您必须为每个授权用户建立一个用户资料，并立即向我们提供您任何建议的授权用户的下列详细资料：客户名称、授权用户名称、客户地址和账单地址、授权用户的电话和电子邮件地址、董事会决议或授权书，以及我们可能合理要求的授权用户的任何其他联系或身份信息。您将确保您的授权用户遵守本条款及细则，就您在本条款及细则下的义务及责任而言，对&ldquo;您&rdquo;的提述（如文义要求）应理解为包括您的授权用户。</p>
<p><strong><strong>7.2指令</strong></strong></p>
<p>我们将通过商户服务平台或UNTONE TECHNOLOGY CO., LIMITEDAPI由UNTONE TECHNOLOGY CO., LIMITED平台从您的授权用户处接收指令，或根据与我们事先商定的安排，通过UNTONE TECHNOLOGY CO., LIMITED的代表人/员工接收指令。</p>
<p><strong><strong>7.3确认</strong></strong></p>
<p>您同意：</p>
<ul>
<li>您的授权用户有权代表您向我们提供服务的指令。</li>
<li>我们将依赖授权用户的授权，而您将受您的授权用户的行为约束，直到您向我们提供书面通知撤回或以其他方式更改授权用户的授权。</li>
<li>您有责任确保适当的人获得必要的授权作为您的授权用户；</li>
<li>如果我们担心未经授权或欺诈性访问，我们可能会拒绝接入您的授权用户；</li>
<li>如有任何侵犯或未经授权访问UNTONE TECHNOLOGY CO., LIMITED平台（包括商户服务平台或UNTONE TECHNOLOGY CO., LIMITEDAPIs）的行为，您应立即向我们报告。</li>
</ul>
<p>&nbsp;</p>
<p><strong><strong>8.收款服务</strong></strong></p>
<p><strong><strong>8.1通过</strong></strong><strong><strong>UNTONE TECHNOLOGY CO., LIMITED</strong></strong><strong><strong>收取资金</strong></strong></p>
<p>如果我们已经为您批准了一种支持币种，您可以根据本条款及细则通过UNTONE TECHNOLOGY CO., LIMITED收取该支持币种的资金。每次收款都是您和UNTONE TECHNOLOGY CO., LIMITED之间的一个单独合同。</p>
<p><strong><strong>8.2您提取收款的权利</strong></strong><strong><strong><br /></strong></strong>UNTONE TECHNOLOGY CO., LIMITED将以我们的名义在一个或多个相关银行账户中收取并持有所收取的资金，用于提供收款服务的指定用途。任何相关银行账户中的资金将与UNTONE TECHNOLOGY CO., LIMITED提供的服务的其他用户的资金集中在一起。作为向您提供的收款服务的一部分，您有权将代您收取的资金指定支付给您。当您要求提款时，UNTONE TECHNOLOGY CO., LIMITED必须根据本条款及细则的规定向您支付这些资金。</p>
<p><strong><strong>8.3记录资金的接收情况</strong></strong></p>
<p>我们只有在收到资金时才会更新您的全球账户。在我们实际收到资金之前，我们不对任何转入的资金负责，也不会将其记录在全球账户中。从您的付款人向UNTONE TECHNOLOGY CO., LIMITED指定的相关账户转账是由第三方提供的服务，而不是我们服务的一部分。我们无法控制该等资金转移到清算和结算所需的时间。</p>
<p><strong><strong>8.4从全球账户中提取资金</strong></strong></p>
<p>您必须立即指示我们提取全球账户中的资金。如果您没有在合理的时间（在任何情况下都不能超过90个工作日或由我们决定）内向我们发出提款指示，我们将自行决定。</p>
<ul>
<li>将资金返还给汇款人；</li>
<li>按照通知我们的方式将资金汇入您绑定的银行账户；</li>
<li>以适用法律允许的任何其他方式将资金汇给您。</li>
</ul>
<p>在作出前述决定后，我们会给您发出书面通知。</p>
<p><strong><strong>8.5资金来源</strong></strong></p>
<p>除非我们另有书面同意，您必须确保为您收取的所有资金均来自合法的商业来源（例如，销售商品或服务的收益），并符合我们的可接受使用政策。您同意向我们提供资金来源的证据。</p>
<p><strong><strong>8.6限制将资金存入全球账户</strong></strong></p>
<p>全球账户只用于向您提供收款服务。</p>
<p><strong><strong>8.7作为有限代理</strong></strong></p>
<p>您向UNTONE TECHNOLOGY CO., LIMITED陈述并保证，您通过收款服务收到的每笔款项均为您向您的客户（各自称为"付款人"）提供真正的商品和/或服务而支付的款项。就收款服务而言，您特此指定UNTONE TECHNOLOGY CO., LIMITED，而UNTONE TECHNOLOGY CO., LIMITED特此同意作为您的有限代理，仅代表您从您的付款人处收取付款。您同意，一旦UNTONE TECHNOLOGY CO., LIMITED收到付款人的付款，则</p>
<ul>
<li>您应被视为已收到该付款人的付款，</li>
<li>该付款人对您所承担的与该付款有关的义务应被完全履行，</li>
<li>您对该付款人的有关付款的任何索赔均应消失，并且</li>
<li>在UNTONE TECHNOLOGY CO., LIMITED将该付款实际支付并汇给您之后，您有义务根据您和该付款人的协议向该付款人交付适用的货物和/或服务。UNTONE TECHNOLOGY CO., LIMITED将根据本条款及细则向您汇款。您应向您的付款人表明，UNTONE TECHNOLOGY CO., LIMITED是作为您的代理人代表您接收付款。提供给付款人的任何收据对您具有约束力，并应满足所有适用的监管要求。本条第7条规定了UNTONE TECHNOLOGY CO., LIMITED作为您在收款服务项下的代理收取款项的全部职责，UNTONE TECHNOLOGY CO., LIMITED承诺以该身份行事。</li>
</ul>
<p><strong><strong>8.8 余额在全球账户中如何表示</strong></strong></p>
<p>在全球账户中收集的资金将在UNTONE TECHNOLOGY CO., LIMITED平台中作为每种支持币种余额的一部分表示，因此在UNTONE TECHNOLOGY CO., LIMITED平台中不会向客户显示单独的全球账户余额。</p>
<p><strong><strong>8.</strong></strong><strong><strong>9</strong></strong><strong><strong>申请开立全球账户</strong></strong></p>
<p>客户可以登录UNTONE TECHNOLOGY CO., LIMITED平台提交开立全球账户的申请，并根据提示在平台上提供所需信息，包括但不限于以下信息：</p>
<ul>
<li>所申请的全球账户的管辖范围、市场和币种；</li>
<li>在创建全球账户之前，UNTONE TECHNOLOGY CO., LIMITED通过平台要求的或UNTONE TECHNOLOGY CO., LIMITED不时要求的任何其他信息。只有当UNTONE TECHNOLOGY CO., LIMITED确信客户已经提供了足够的细节和信息来为客户开立全球账户，并且UNTONE TECHNOLOGY CO., LIMITED能够核实这些信息时，UNTONE TECHNOLOGY CO., LIMITED才会为客户创建全球账户。UNTONE TECHNOLOGY CO., LIMITED保留拒绝为客户开立全球账户的权利。</li>
</ul>
<p><strong><strong>8.</strong></strong><strong><strong>10</strong></strong><strong><strong>如何将资金转入全球账户</strong></strong></p>
<ul>
<li>客户需要登录UNTONE TECHNOLOGY CO., LIMITED平台，并获取相关支持币种的全球账户的虚拟/附属账户信息。在UNTONE TECHNOLOGY CO., LIMITED实际收到资金之前，UNTONE TECHNOLOGY CO., LIMITED不对转账资金负责。</li>
<li>客户或任何付款人可以通过银行转账，使用UNTONE TECHNOLOGY CO., LIMITED在UNTONE TECHNOLOGY CO., LIMITED平台上显示的虚拟/附属账户信息或UNTONE TECHNOLOGY CO., LIMITED通过UNTONE TECHNOLOGY CO., LIMITED平台不时允许的任何其他方式将资金转入全球账户。</li>
<li>向全球账户转账不属于UNTONE TECHNOLOGY CO., LIMITED提供的服务，而是由第三方向客户提供的服务。提供给客户的全球账户仅用于在合法合规的商品交易或提供服务的背景下从电商平台或交易方收取资金，因此提供给客户的全球账户只能用于存款。在此情况下，除非经UNTONE TECHNOLOGY CO., LIMITED同意，否则客户不得使用该账户进行任何直接扣款服务，包括但不限于定期自动扣取水电费或租金、退还销售收入、定期支付服务费和/或等。当客户的全球账户发生任何直接扣款交易时，UNTONE TECHNOLOGY CO., LIMITED有权拒绝或终止该交易但需书面通知客户。</li>
</ul>
<p>&nbsp;</p>
<p><strong><strong>9.外汇兑换服务</strong></strong></p>
<p><strong><strong>9.1您对外汇兑换的指令</strong></strong></p>
<p>您可以在UNTONE TECHNOLOGY CO., LIMITED平台按照以下步骤提供必要的信息，指令我们进行外汇兑换：</p>
<ul>
<li>客户应通过UNTONE TECHNOLOGY CO., LIMITED平台提交与外汇交易有关的客户请求，其中包括但不限于以下信息：</li>
<li>买入币种和卖出币种的币种配对；</li>
<li>买入币种和卖出币种的金额；</li>
<li>结算日期（如适用）；以及</li>
</ul>
<p>(iv) UNTONE TECHNOLOGY CO., LIMITED在发出订单确认之前通过UNTONE TECHNOLOGY CO., LIMITED平台不时要求的任何其他信息。</p>
<ul>
<li>在收到客户请求后，UNTONE TECHNOLOGY CO., LIMITED将随后发送一份订单确认书，确认客户请求的细节。该订单确认应包含最终确定的外汇汇率，该汇率可能与最初向客户提供的外汇汇率不同。UNTONE TECHNOLOGY CO., LIMITED应在合理可行的情况下，努力使UNTONE TECHNOLOGY CO., LIMITED代理银行或流动性提供者提供的最终外汇汇率密切反映出首次向客户报价的外汇汇率。</li>
<li>如果订单确认上列明的日期不是工作日，那么该日期将调整为下一个最近的工作日的第一天。</li>
<li>当UNTONE TECHNOLOGY CO., LIMITED认为客户已经提供了足够的细节和信息以完成订单确认时，外汇交易才成立并具有约束力。</li>
<li>UNTONE TECHNOLOGY CO., LIMITED可以通过商户服务平台、外汇API或其他任何UNTONE TECHNOLOGY CO., LIMITED认为合适的方式发送订单确认。</li>
<li>向客户发出订单确认意味着客户已经预订了该交易。</li>
</ul>
<p><strong><strong>9.2外汇兑换的确认</strong></strong></p>
<p>当我们确信您的指令已完成，我们将向您发出有关外汇兑换的确认。如果您在结算截止日没有足够的资金、您超过了任何适用的限额、您要求的外汇兑换被我们视为杠杆式外汇交易，或根据第19条，我们可能会拒绝您的指令。一旦确认发出，您不能取消外汇兑换，并被视为最终确认。然后，您必须根据本条款及细则的规定，以相关源币种与我们进行全额外汇兑换结算。</p>
<p><strong><strong>9.3外汇汇率</strong></strong></p>
<p>您可以通过UNTONE TECHNOLOGY CO., LIMITED平台获取外汇兑换的指示性外汇汇率。当您通过UNTONE TECHNOLOGY CO., LIMITED平台向我们发出指示时，我们将向您提供指示性外汇汇率，而最终的外汇汇率将在我们发出确认书时予以确认。我们将在合理可行的情况下确保确认的外汇汇率反映向您提供的汇率，但您明白这并非总是可能的。由于在您发出指示至我们发出确认书期间，汇率可能会有所改变，因此用于进行外汇兑换的最终外汇汇率可能会有所不同。您同意，汇率的变化将立即生效，恕不另行通知。</p>
<p><strong><strong>9.4外汇兑换的结算规定</strong></strong></p>
<p>您必须在结算截止日或之前以相关源币种向备付金银行账户支付足够的资金，以支付您希望进行的任何外汇兑换的全部金额。您可透过直接银行转账或其他可接受的方式为外汇兑换提供资金。在不影响我们在本条款及细则下的任何权利的前提下，您有义务在我们提出要求后两（2）个工作日内，或按照约定的结算日期，将该等款项支付到我们指定的账户，您明确承认，如果您未能就任何外汇兑换交易支付我们要求的任何保证金，或没有向备付金银行账户支付足够的资金以支付全部款项，我们可以取消外汇兑换交易，而无需事先通知您，并将保证金用于支付任何应付给我们的款项。</p>
<p><strong><strong>9.5外汇兑换的执行时间</strong></strong></p>
<p>如果您要求我们进行外汇兑换，我们将在合理可行的情况下尽快进行，在任何情况下，即不超过我们接受您的指令后24小时内。</p>
<p><strong><strong>9.6外汇兑换即期交易的要求</strong></strong></p>
<p>除非UNTONE TECHNOLOGY CO., LIMITED在提交非实时结算的即期外汇交易的客户请求之日或之前从客户的银行账户中收到相当于客户请求中所述卖出币种金额2%（该等金额可能会根据市场要求而有所不同，UNTONE TECHNOLOGY CO., LIMITED应至少7个工作日的提前通知客户。）作为客户保证金，否则UNTONE TECHNOLOGY CO., LIMITED没有义务与客户进行任何外汇交易和/或付款。</p>
<p>&nbsp;</p>
<p><strong><strong>10.付款服务</strong></strong></p>
<p><strong><strong>10.1您对付款的指示</strong></strong></p>
<p>您可以通过提供UNTONE TECHNOLOGY CO., LIMITED平台上提示的必要信息来指示我们进行付款。如果某项付款涉及到支持货币之间的货币转换（例如，源币种与支付币种不同），我们还将向您提供外汇兑换服务，作为支付服务的附属服务。每笔付款，包括任何带有外汇兑换的付款，都是您和UNTONE TECHNOLOGY CO., LIMITED之间的一个单独合同。</p>
<p><strong><strong>10.2付款确认</strong></strong></p>
<p>当我们确信您的指令是完整的，我们将向您发出有关付款的确认。如果您在结算截止日前没有足够的资金，或者您超过了任何适用的限额，或者根据第19条，我们可能会拒绝您的指令。一旦确认发出，您不能取消付款，并被视为最终确认。然后，您必须按照本条款及细则的规定与我们进行全额结算。</p>
<p><strong><strong>10.3付款服务的结算要求</strong></strong></p>
<p>您必须以相关的源币种向备付金银行账户支付足够的资金，以支付您希望在结算截止日或之前作出的任何付款的全部金额。您可通过直接银行转账或其他我们接受的方式向我们付款。在不影响我们在本条款及细则下的任何权利的前提下，您明确同意，如果您的备付金银行账户中没有足够的资金来支付全额款项，我们可以从您的全球账户中为您收集和持有的资金或您的UNTONE TECHNOLOGY CO., LIMITED平台中的任何余额中扣除或抵消该款项。如果您以非付款币种的货币转入备付金银行账户，或如果您的全球账户中的资金或您的UNTONE TECHNOLOGY CO., LIMITED平台中的任何货币（我们用于抵销）不是付款币种，您授权我们在付款日按我们的提出请求时可获得的标准汇率将该币种兑换成付款币种。</p>
<p><strong><strong>10.4付款服务的执行时间</strong></strong></p>
<p>如果您要求我们进行付款，我们将在合理可行的情况下尽快进行支付，在任何情况下，即不超过我们接受您的指示后24小时内。贷记资金的方法可能由第三方（例如，收款人的银行账户所在的银行）提供，而不是我们服务的一部分。我们无法控制收款人的银行或支付提供商向收款人贷记资金所需的时间，但一般情况下，我们预计这需要少于5个工作日（除非我们要求更长的时间以符合适用法律）。如果付款确认上指定的日期不是工作日，那么该日期将被调整到下一个最近的工作日的第一天。</p>
<p><strong><strong>10.5付款服务的指令</strong></strong></p>
<ul>
<li>客户应通过UNTONE TECHNOLOGY CO., LIMITED平台提交与付款有关的客户请求，其中包括但不限于以下信息：</li>
<li>为客户规定的&ldquo;了解您的客户&rdquo;("KYC")详情；</li>
<li>为付款人和收款人规定的&ldquo;了解您的客户&rdquo;("KYC")详情；</li>
<li>收款人的银行账户详情；</li>
<li>源币种和付款币种；</li>
<li>付款金额；</li>
<li>付款日期；以及</li>
<li>指定的付款方式（如果没有指定付款方式，UNTONE TECHNOLOGY CO., LIMITED保留使用任何付款方式处理付款的权利）。</li>
<li>当UNTONE TECHNOLOGY CO., LIMITED认为客户已经提供了足够的细节、证明文件和信息以完成付款确认时，付款才会成立并具有约束力。</li>
</ul>
<p>&nbsp;</p>
<p><strong><strong>11.撤消和拒绝</strong></strong></p>
<p><strong><strong>11.1撤销</strong></strong></p>
<p>我们可能需要对与服务有关的任何资金进行撤销，并扣除我们已收到的作为服务一部分的资金，或退还我们已收到的作为服务一部分的资金，包括但不限于以下情况：</p>
<ul>
<li>汇款人或任何相关的支付服务提供商撤销交易或可能撤销交易；</li>
<li>汇款人误将钱转给了您；</li>
<li>您向我们提供了错误的交易指令；</li>
<li>我们怀疑某项交易是欺诈性的，或违反了本条款及细则或适用法律；</li>
<li>我们根据第19条行使我们的权利。</li>
</ul>
<p>您必须按照第12.5条的规定，尽快向我们补偿。如果我们撤销交易，我们将自行决定按撤销时适用的外汇汇率或适用于该交易的原始外汇汇率进行。</p>
<p><strong><strong>11.2拒绝的交易</strong></strong></p>
<p>在以下情况下，我们可能会扣留、拒绝或延迟接收任何收到、交换或发送的资金：</p>
<ul>
<li>我们的代理银行合作伙伴、流动资金提供者或其他金融机构没有提供有效的汇率；</li>
<li>超过任何有关的反洗钱或打击资助恐怖主义行为的限制；</li>
<li>您没有遵守本条款及细则、可接受使用政策或适用法律规定的义务；</li>
<li>我们根据第19条行使我们的权利。</li>
</ul>
<p><strong><strong>11.3失败的交易</strong></strong></p>
<p>如果由于我们合理控制范围以外的原因（如资金不足），我们可以自行决定取消任何外汇兑换或付款，或通过将其滚动到下一个最近的兑换日或付款日（如适用）来延迟任何外汇兑换或付款，而无需对您负责。</p>
<p><strong><strong>11.4资金不足</strong></strong></p>
<p>如果在结算截止日时，有一笔或多笔外汇兑换和/或付款的资金不足，UNTONE TECHNOLOGY CO., LIMITED保留有权进行外汇兑换或付款的权利（例如，按时间计算，将最早预订的外汇兑换或付款兑换至UNTONE TECHNOLOGY CO., LIMITED在适用的兑换日或付款日的可用资金价值）。其余已预订的外汇兑换将被视为失败交易，并将产生相关的中断成本和管理费用。</p>
<p><strong><strong>11.5使用正确的信息转账</strong></strong></p>
<ul>
<li>在每一种情况下，您都需要确保使用正确的银行信息和UNTONE TECHNOLOGY CO., LIMITED列明的唯一交易参考号码信息将资金转给我们。如果您没有提供准确的信息，那么我们可能无法收到资金并将金额记录在相关账户中。在这种情况下，虽然我们会尽合理的努力调查并将错误的和不准确的付款存入或从您的账户中返还，但我们不会对您可能遭受或产生的任何损失负责。</li>
<li>如果客户请求中包含的错误付款指令与之前的外汇交易有关，当客户因提供错误的付款指令而选择取消客户请求，则客户应承担通过UNTONE TECHNOLOGY CO., LIMITED平台预订撤销外汇交易的费用。</li>
<li>如果客户因错误的付款指令而取消客户请求，并提交新的客户请求以退回客户资金，UNTONE TECHNOLOGY CO., LIMITED不保证UNTONE TECHNOLOGY CO., LIMITED退回的金额或货币与付款货币和/或金额一致。</li>
<li>平台在客户请求中提供了错误的外汇交易指示（可能包括但不限于错误的结算日期、无效的货币配对和/或错误的买入货币或卖出货币金额），客户同意在可行的情况下尽快向UNTONE TECHNOLOGY CO., LIMITED提供正确的客户请求，或取消该客户请求。在取消客户请求后，客户必须向UNTONE TECHNOLOGY CO., LIMITED提供新的客户请求，以便将错误的客户请求所涉及的客户资金返还给客户。</li>
<li>如果UNTONE TECHNOLOGY CO., LIMITED无法从相关代理银行或流动性提供者处获得有效的利率，UNTONE TECHNOLOGY CO., LIMITED有权拒绝客户的更正请求。</li>
<li>客户应赔偿UNTONE TECHNOLOGY CO., LIMITED因客户未遵守本条款规定的程序而直接导致的任何付款失败而遭受的任何合理损失。</li>
</ul>
<p><strong><strong>11.6超额资金</strong></strong></p>
<p>当您向备付金银行账户付款时，您必须就付款或外汇兑换向我们发出准确及完整的指令。如您没有向我们提供准确或完整的指令，我们可自行决定：</p>
<ul>
<li>将资金退回给汇款人；</li>
<li>按照通知我们的方式将资金汇入您绑定的银行账户；</li>
<li>在符合任何适用法律的情况下，以任何其他方式将资金汇给您。</li>
</ul>
<p>&nbsp;</p>
<p><strong><strong>12.安全和保障</strong></strong></p>
<p><strong><strong>12.1账户安全</strong></strong></p>
<p>为了使用UNTONE TECHNOLOGY CO., LIMITED平台，您（或您的授权用户）必须使用唯一的密码和任何多重因素认证来登录：例如，我们可能会要求您的授权用户在登录UNTONE TECHNOLOGY CO., LIMITED平台时，或在使用UNTONE TECHNOLOGY CO., LIMITED平台进行某些交易时，验证他们是授权用户。您必须始终安全可靠地保存所有登录信息和密码以访问UNTONE TECHNOLOGY CO., LIMITED平台，并只允许授权用户访问服务。</p>
<p><strong><strong>12.2账户资料泄露</strong></strong></p>
<p>如果您怀疑您的密码被泄露，请立即发送电子邮件至cs@sprout-pay.com并更改密码。UNTONE TECHNOLOGY CO., LIMITED会对您的要求作出即时反应（即邮件汇报前述泄露的30分钟内）</p>
<ul>
<li>您的UNTONE TECHNOLOGY CO., LIMITED账户，或进入UNTONE TECHNOLOGY CO., LIMITED平台或其他安全凭证被窃取、遗失、未经您的授权而使用，或以其他方式受到损害；</li>
<li>别人发现您的UNTONE TECHNOLOGY CO., LIMITED账户或用户资料的登录信息和密码。</li>
</ul>
<p>任何不适当的延迟通知我们的行为可能会影响您的UNTONE TECHNOLOGY CO., LIMITED账户的安全，或影响您访问UNTONE TECHNOLOGY CO., LIMITED平台，并可能导致您对任何经济损失负责。</p>
<p><strong><strong>12.3请定期查看您的账户交易情况</strong></strong></p>
<p>您的所有活动都会在UNTONE TECHNOLOGY CO., LIMITED平台上显示。如果您怀疑或实际发生了未经授权的交易或其他有关UNTONE TECHNOLOGY CO., LIMITED平台的安全问题，您必须立即发送电子邮件至cs@sprout-pay.com联系我们。如果交易是由于我们的错误、欺诈或您的交易错误造成的，我们可能会退还您的损失（见第12.4条）。如果您没有立即通知我们任何未经授权、或错误发起或执行的交易，您可能会失去要求纠正问题或退款的权利。在以下情况下，您也可能无法要求退款：</p>
<ul>
<li>您违反了本条款及细则或任何适用法律；</li>
<li>您向我们提供了错误的交易指示（在这种情况下，我们可能会在可能的情况下合理地帮助您收回资金，但我们不保证会成功）；</li>
<li>任何损失都不是我们的行为或疏忽直接造成的。</li>
</ul>
<p><strong><strong>12.4未经授权的交易</strong></strong><strong><strong><br /></strong></strong>对于在UNTONE TECHNOLOGY CO., LIMITED直接控制范围之外的未经授权的交易，我们不承担任何责任。特别是在下述情形（但不限于此），我们不承担任何责任（而您将对所有损失负全部责任）：</p>
<ul>
<li>如果您不及时通知我们安全问题；</li>
<li>如果我们发现您或您的授权用户或代表您的其他任何人有欺诈的行为；</li>
<li>如果您故意或因严重疏忽而损害了您的UNTONE TECHNOLOGY CO., LIMITED账户或UNTONE TECHNOLOGY CO., LIMITED平台的安全，或您未能按照本条款及细则履行使用这些数据的义务，以及未能保持所有登录数据和密码保密和安全；</li>
<li>如果您给了我们错误的付款指示（我们可能会合理地帮助您收回资金，但我们不保证会成功）；</li>
<li>在适用法律允许的范围内，在我们直接控制之外的任何其他情况下。</li>
</ul>
<p><strong><strong>12.5偿还</strong></strong></p>
<p>如果我们向您退还未经授权交易的款项，但随后发现您没有遵守本条款第12条规定的义务，您必须向我们偿还未经授权交易的价值。</p>
<p><strong><strong>12.6确认</strong></strong></p>
<p>您同意：</p>
<ul>
<li>对于您通过UNTONE TECHNOLOGY CO., LIMITED平台进行的任何交易，UNTONE TECHNOLOGY CO., LIMITED不承担任何责任，也不作任何保证；</li>
<li>您必须获得并使用您使用或连接UNTONE TECHNOLOGY CO., LIMITED平台所需的任何设备或电信线路和连接；</li>
<li>您使用的某些软件和设备可能无法支持UNTONE TECHNOLOGY CO., LIMITED平台的某些功能；</li>
<li>您有责任配置和更新您的信息技术、软件和设备，以便使用本服务或UNTONE TECHNOLOGY CO., LIMITED平台。</li>
</ul>
<p><strong><strong>12.7您的责任</strong></strong></p>
<p>您应对UNTONE TECHNOLOGY CO., LIMITED因以下原因或与以下原因有关而遭受或产生的所有合理成本、收费、索赔、损害赔偿、费用、损失、支出、罚款和责任负责：</p>
<ul>
<li>（如适用）您的错误指示、超额支付、支付错误或您导致的其他无效支付；</li>
<li>您、您的雇员、董事、高级职员或代表或任何代表您的人的任何错误、违约、疏忽、不当行为或欺诈行为；以及</li>
<li>因您未能遵守本条款及细则，包括但不限于本条款第12条，而使UNTONE TECHNOLOGY CO., LIMITED遭受或招致的任何成本、收费、索赔、损害赔偿、费用、损失、开支、罚款和责任。</li>
</ul>
<p>&nbsp;</p>
<p><strong><strong>13.费用和收费</strong></strong></p>
<p><strong><strong>13.1服务费</strong></strong></p>
<p>您将为服务向我们支付服务费，或者根据载于我们网站的费用表，或根据与我们另有书面约定。服务费根据您所使用的服务而单独收取，例如：</p>
<ul>
<li>收款服务。收款服务的费用一般包括按资金的一定百分比收费和/或按每笔交易、和/或按每日、每周、每月或每年等周期收取的固定费用；</li>
<li>付款服务。付款服务的服务费一般都会涉及到费用，这取决于您使用的支付渠道、支付金额和/或按每笔交易、和/或按每日、每周、每月或每年等周期收取的固定费用；</li>
<li>外汇兑换服务。外汇兑换服务的服务费一般涉及在外汇基本汇率之上收取客户汇率价差和/或按每笔交易、和/或按每日、每周、每月或每年等周期收取的固定费用；</li>
<li>UNTONE TECHNOLOGY CO., LIMITED平台服务。可能会按一定时间收取服务费，例如因商户使用UNTONE TECHNOLOGY CO., LIMITED平台服务向UNTONE TECHNOLOGY CO., LIMITED发起充值、提现、查询、对账、个性化设置等系统的或电子指令，按月收取。</li>
</ul>
<p><strong><strong>13.2服务费的变更</strong></strong></p>
<p>除非我们以书面形式另行同意，否则我们可以随时修改服务费，修改后的服务费将在我们通知您服务费适用的日期生效。</p>
<p><strong><strong>13.3税</strong></strong><strong><strong><br /></strong></strong>根据本条款及细则应付给我们的所有款项：</p>
<ul>
<li>不包括现在生效或将来颁布的所有税费和类似费用，所有这些费用您都将负责并全额支付；</li>
<li>除非适用法律禁止，否则将全额支付，不得有任何抵销、索赔、扣减或预扣。如果适用法律要求您从任何付款中扣除预扣税：</li>
<li>您应立即通知UNTONE TECHNOLOGY CO., LIMITED有关要求；</li>
<li>双方应进行所有必要的申报，以确保任何适用的税务条约的规定适用于该笔付款；</li>
<li>您应向UNTONE TECHNOLOGY CO., LIMITED支付额外的金额，使以UNTONE TECHNOLOGY CO., LIMITED收到在没有预扣或扣除的情况下本应收到的全部金额。</li>
<li>您将向相关机构支付到期的全额扣款或预扣款；以及</li>
<li>(您将立即向UNTONE TECHNOLOGY CO., LIMITED提交正式收据（或经核证的副本）或UNTONE TECHNOLOGY CO., LIMITED合理接受的其他文件，以证明已向该机构支付款项。</li>
</ul>
<p><strong><strong>13.4支付欠款的义务</strong></strong></p>
<p>您必须在7个工作日内向我们支付任何欠款，包括因任何撤销、退款、费用、收费或其他交易而导致的欠款，如逾期，则我们可能会暂停您对服务的使用（但不包括对任何相关账户的访问），直到我们收到该等付款。</p>
<p><strong><strong>13.5扣除您欠我们款项的权力</strong></strong></p>
<p>我们可以不时从我们收取或收到的作为服务的一部分的资金中，或从根据本条款及细则第13.6条提供的作为担保的任何金额中扣除您欠我们的任何金额。如果您没有足够的资金来支付您欠我们的款项，我们可以在需要您承担费用的情况下，采取合理的行动来追回这笔款项（例如采取法律行动或使用追债服务）。</p>
<p><strong><strong>13.6担保</strong></strong></p>
<p>我们可以在任何时候要求您在收到我们的书面请求后30天内（或我们可能确定的更长时间），按我们的合理要求以我们合理要求的形式和资产提供担保或赔偿（包括替换任何现有的担保），以确保我们合理满意地履行您根据本条款及细则不时承担的义务（包括或有或潜在的义务）。</p>
<p><strong><strong>13.7服务费的支付方式</strong></strong></p>
<ul>
<li>对于每笔单笔交易中发生的费用：当每笔交易被UNTONE TECHNOLOGY CO., LIMITED成功确认后，UNTONE TECHNOLOGY CO., LIMITED将根据扣款时外汇市场的汇率，直接从客户的预存款账户余额中以实际扣款币种扣除等值的费用金额（若实际费用币种与扣款币种相同，则不发生外汇兑换）。当余额不足时，客户有义务及时补足，并对因余额不足造成的问题负责。</li>
<li>对于固定费用。UNTONE TECHNOLOGY CO., LIMITED会根据扣除时外汇市场的汇率，于每月一（1）日从客户的预存款账户余额中以交易的实际借记币种扣除任何固定费用金额（若实际费用币种与借记币种相同，则不发生外汇兑换）。当余额不足时，客户有义务在被通知后的5个工作日内补足，并对因余额不足造成的问题负责。</li>
<li>安装费和其他一次性费用。UNTONE TECHNOLOGY CO., LIMITED将向客户发出安装费和其他一次性费用的发票，客户应在每月第一(1)日继续使用任何服务前全额支付。客户应接受发票并立即将款项汇入发票上指定的收款银行账户。</li>
</ul>
<p>&nbsp;</p>
<p><strong><strong>14.知识产权</strong></strong></p>
<p><strong><strong>14.1</strong></strong><strong><strong>授权</strong></strong></p>
<p>让您在遵守本条款及细则的前提下，我们授予您一个个人的、可撤销的、不可转让的、不可转授的和非独家的授权以通过任何支持的网络浏览器进入和使用UNTONE TECHNOLOGY CO., LIMITED平台，以管理我们的服务。</p>
<p><strong><strong>14.2所有权</strong></strong></p>
<p>我们拥有UNTONE TECHNOLOGY CO., LIMITED平台及其专有技术的所有知识产权，包括其软件（源码和对象形式）、算法、用户界面设计、架构和文件（包括印刷的和电子的）、网络设计，以及包括任何修改、改进和衍生作品。本条款及细则并不意味着UNTONE TECHNOLOGY CO., LIMITED向您转移UNTONE TECHNOLOGY CO., LIMITED平台和/或其专有技术的任何所有权。</p>
<p><strong><strong>14.3使用限制</strong></strong></p>
<p>除了在第14.1条许可授权使用我们的服务的权利外，您对我们的服务（包括UNTONE TECHNOLOGY CO., LIMITED平台）不拥有任何权利。除非法律要求或UNTONE TECHNOLOGY CO., LIMITED允许，否则您不得复制、修改、改编、翻译、创作衍生作品、转让、出借、出租、再许可、出售、构架或以其他方式重新发布或重新分发、公开表演或公开展示UNTONE TECHNOLOGY CO., LIMITED平台、服务或所含软件的任何部分。您不得允许任何未经授权的人进入或使用UNTONE TECHNOLOGY CO., LIMITED平台，或在UNTONE TECHNOLOGY CO., LIMITED平台进行投机性交易。除适用法律明确允许外（但不是其他情况），您也不能对UNTONE TECHNOLOGY CO., LIMITED平台或软件进行反向工程、反编译、反汇编或试图提取其源代码。</p>
<p><strong><strong>14.4使用您的数据</strong></strong></p>
<p>UNTONE TECHNOLOGY CO., LIMITED仅仅履行本条款及细则规定的义务的必要性范围内使用您的任何数据，且非经您的书面批准，不会向任何第三方披露。您应对通过UNTONE TECHNOLOGY CO., LIMITED平台传输的任何客户数据和支付数据的质量、准确性和完整性负全部责任。</p>
<p><strong><strong>14.5其他人的权利</strong></strong></p>
<p>您不得以任何方式使用包括UNTONE TECHNOLOGY CO., LIMITED平台在内的我们的服务去侵犯或违反我们或其他任何人的版权、商标或其他知识产权，或以其他方式违反任何适用法律。UNTONE TECHNOLOGY CO., LIMITED平台可能会显示我们并无所有权的内容，我们对此不负任何责任。</p>
<p><strong><strong>14.6宣传</strong></strong></p>
<p>除非获得您的事先许可，UNTONE TECHNOLOGY CO., LIMITED不会使用您的商业信息纳入UNTONE TECHNOLOGY CO., LIMITED服务的一般宣传材料中。</p>
<p>&nbsp;</p>
<p><strong><strong>15.数据的保密、隐私和使用</strong></strong></p>
<p><strong><strong>15.1保密信息</strong></strong></p>
<p>您承认，您可能会接触到属于我们的保密信息，您必须根据本条款及细则的规定对这些信息进行保密。</p>
<p><strong><strong>15.2保密承诺</strong></strong></p>
<p>您同意，您：</p>
<ul>
<li>不会向任何第三方披露我们的任何保密信息，除非另有要求：.</li>
<li>法律或任何有管辖权的机构要求；</li>
<li>在合理必要的情况下向您的律师、会计师和其他顾问提供；或</li>
<li>为了在实际或威胁的诉讼中为自己辩护；</li>
</ul>
<p>但就上述(i)至(iii)项而言，您会（于适用法律允许向我们发出通知的情况下）提前合理通知我方所需的披露，并提供我方可能要求的详细信息；</p>
<ul>
<li>将采取合理的预防措施来保护这些信息的机密性，至少要与保护您自己的保密信息的措施一样严格。</li>
</ul>
<p><strong><strong>15.3向雇员和代理披露</strong></strong></p>
<p>此外，您只能向您的代理人、代表和雇员透露我们的保密信息，这些代理人、代表和雇员"有必要知道"与本条款及细则有关的信息，他们被告知这些保密信息的保密性质，并同意按照第15条的条款和条件行事。</p>
<p><strong><strong>15.4隐私和个人数据</strong></strong></p>
<p>保护个人数据对我们非常重要。除了本条款及细则外，我们的隐私政策还解释了我们如何以及出于何种目的收集、使用、保留、披露和保护您向我们提供的个人数据。您同意查看我们不时更新的隐私政策条款。</p>
<p>目的。在合法的范围内，您同意与UNTONE TECHNOLOGY CO., LIMITED分享个人数据，并授权UNTONE TECHNOLOGY CO., LIMITED收集、使用、储存或以其他方式处理该等个人数据作以下&ldquo;协议目的&rdquo;，使我们能够：</p>
<ul>
<li>协助向您提供有关产品或服务的信息；</li>
<li>考虑您对产品或服务的要求；</li>
<li>使我们能够提供产品或服务；</li>
<li>管理UNTONE TECHNOLOGY CO., LIMITED与客户的关系；</li>
<li>管理账户和执行其他管理和业务任务（包括风险管理、系统开发和测试、信用评分、员工培训、催收债务和市场或客户满意度调查）；</li>
<li>设计新的产品和服务或改进我们提供的现有产品和服务；</li>
<li>我们与您之间的一般和特定的通信；</li>
<li>考虑您对我们提出的任何疑虑或投诉，管理涉及UNTONE TECHNOLOGY CO., LIMITED的任何法律行动，或两者；</li>
<li>进行任何执行活动，包括向您收取任何款项；</li>
<li>根据任何当地或外国的法律、法规或条约，或根据与任何税务机关的协议，确定您的身份或确立您的税务地位；</li>
<li>识别、防止或调查任何欺诈、非法活动或不当行为（或涉嫌欺诈、非法活动或不当行为）；</li>
<li>遵守所有适用法律，包括进行反洗钱、金融犯罪和其他检查；</li>
<li>核实与您有关的任何信息和记录；</li>
<li>遵守本条款及细则和隐私政策；</li>
<li>使我们全部或任何部分业务及/或资产的实际或潜在受让人能够评估拟作为转让标的的交易，并使实际受让人能够在业务运营中使用您提供的个人数据；以及</li>
<li>用于我们的隐私政策中规定的任何其他目的。</li>
</ul>
<p>您可以随时通过书面（包括Email）至第2.2条所记载的联系方式处，撤销前述授权。</p>
<p><strong><strong>15.5数据主体</strong></strong></p>
<p>我们可能收集的数据主体类别可能包括以下自然人：客户、客户的董事和最终受益所有人、您的客户、雇员和承包商、付款人和收款人。您可能会与UNTONE TECHNOLOGY CO., LIMITED分享因服务而了解到的下列有关数据主体的部分或全部个人数据。</p>
<ul>
<li>全名；</li>
<li>电子邮件地址；</li>
<li>电话号码和其他联系信息；</li>
<li>出生日期；</li>
<li>国籍；</li>
<li>关于数据主体的公共信息；</li>
<li>本条款及细则所要求的其他相关核查或尽职调查文件；以及</li>
<li>执行协议目的所需或相关的任何其他数据。</li>
</ul>
<p><strong><strong>15.6合规</strong></strong></p>
<p>任何一方都不会故意履行其在本条款及细则下的义务而导致另一方违反适用的数据保护法规。对于另一方未能遵守与其共享的个人数据有关的适用数据保护法规所导致的任何后果，双方均不承担责任。</p>
<ul>
<li>您承诺每一笔通过UNTONE TECHNOLOGY CO., LIMITED完成的支付交易信息均真实有效，具有真实合法的交易背景，确保结算资金来源和流向的合法合规性。并应当按照UNTONE TECHNOLOGY CO., LIMITED规范要求向UNTONE TECHNOLOGY CO., LIMITED提交可证明交易真实性的每笔交易明细，包括但不限于交易双方信息、交易商品名称、交易商品数量、交易时间、交易金额、付款信息、物流信息、消费者签收回执单或协议等信息，因您伪造交易明细及合作资料所产生的一切责任由您独立承担。</li>
<li>您应对所有通过UNTONE TECHNOLOGY CO., LIMITED所产生的交易信息及资料文件承担保存义务，在本协议有效期内本协议终止后至少5年内（若法律法规有更长时间的规定，则以法律法规规定为准）保存所有的尽职调查文件。您需确保在接到我们通知或在香港打击洗钱条例的保存记录所列明的期间做出要求时，您应在合理切实可行的范围内，尽快向我们提供您在履行尽职调查措施时取得的任何文件、数据或资料的记录。</li>
<li>我们会不定时进行抽查，您应在我们要求时尽快提供尽职审查的资料或文件。</li>
<li>我们有合理理由怀疑您的可靠性，我们可当即采取措复核您履行尽职调查的能力。</li>
</ul>
<p><strong><strong>15.7承诺</strong></strong></p>
<p>在您或UNTONE TECHNOLOGY CO., LIMITED处理个人数据的范围内，每一方将：</p>
<ul>
<li>公平、合法地处理个人数据，并确保其在数据保护法规下有合法理由进行处理；</li>
<li>获得并维持数据保护法规所要求的所有适当的注册，以允许其根据本条款及细则使用个人数据；</li>
<li>确保采取适当的技术和组织安全措施，以保护其控制下的个人数据；</li>
<li>确保所有能够接触和/或处理个人数据的人员有义务对其进行保密；</li>
<li>只有在采取适当措施使数据保护法规定的转移合法的情况下，才会在不同的司法管辖区之间转移个人数据；</li>
<li>如果收到数据主体或监管机构向另一方提出的或针对另一方的任何请求、投诉或其他通信，应立即通知对方；</li>
<li>如果发现与对方直接相关的个人数据泄露，应及时通知对方。</li>
</ul>
<p><strong><strong>15.8数据安全</strong></strong></p>
<p>除了我们规定的任何其他合理的信息安全要求外，您将确保传输给UNTONE TECHNOLOGY CO., LIMITED的任何个人数据的方法和手段是安全的，并符合数据保护法规。</p>
<p><strong><strong>15.9合作</strong></strong></p>
<p>各方将负责回应监管机构或个人根据适用的《数据保护法》规行使其权利的请求。各方将向对方提供合理的合作和协助，以遵守数据保护法规和任何相关适用法律对其规定的所有义务，包括：</p>
<ul>
<li>处理及回应数据主体的任何通讯；</li>
<li>处理、减轻及回应任何个人数据泄露事件；以及</li>
<li>就安全、影响评估及与管理机关或监管机构磋商。</li>
</ul>
<p><strong><strong>15.10数据处置</strong></strong></p>
<p>在本条款及细则终止时，或一旦处理任何个人数据不再是执行目的所必需的，各方将根据适用法律的要求安全地处置其拥有的任何此类个人数据。</p>
<p><strong><strong>15.11数据安全</strong></strong></p>
<p>我们将采取数据保护法规所要求的一切步骤，确保对此类披露采取适当的信息安全保障措施。</p>
<p><strong><strong>15.12您提供的有关他人的个人数据</strong></strong></p>
<p>如果您向我们提供有关他人的个人数据，包括（但不限于）您的授权用户、您的董事和最终受益所有人、您的客户、雇员和承包商、付款人和收款人，您承诺我们可以依赖您获得该等人士的同意，向我们披露他们的个人数据，我们将根据本条款及细则的规定使用这些资料。您须向该等人士出示有关本条款的信息，以便该等人士了解，在您与我们的交易中，UNTONE TECHNOLOGY CO., LIMITED可能收集、使用及披露其个人数据的方式，以及我们对其个人数据的使用。</p>
<p>&nbsp;</p>
<p><strong><strong>16.披露信息和使用个人数据进行直接营销</strong></strong></p>
<p><strong><strong>16.1我们可能会向其他人披露您的信息。</strong></strong></p>
<p>UNTONE TECHNOLOGY CO., LIMITED可能会将您的客户数据、支付数据和个人数据，包括任何保密信息披露给：</p>
<ul>
<li>UNTONE TECHNOLOGY CO., LIMITED的任何分公司、子公司、控股公司、关联公司、附属公司或相关实体；</li>
<li>我们聘请或建议聘请的任何代理人、承包商或服务提供商，以执行或协助我们的职能和活动，并有责任对这些信息保密；</li>
<li>支付系统的参与者，包括卡组织、金融机构和支付组织，如环球银行间金融电信协会；</li>
<li>UNTONE TECHNOLOGY CO., LIMITED可能与之签订任何转让、融资、股份购买或其他商业协议，并有义务对该信息保密的任何人；</li>
<li>任何适用法律或法规或根据任何法院命令允许或要求（或预期）向其披露信息的任何人；</li>
<li>任何推荐人或代表或您的代表（包括任何专业顾问、经纪人、介绍人、律师或执行人）；</li>
<li>抵押、担保或信贷支持的任何第三方提供者（如有）；</li>
<li>信用调查机构，以及在发生违约的情况下，给追债机构；</li>
<li>您授权的或根据法律授权的任何代理人，如破产管理人或受信托人或您的法定代表人；以及</li>
<li>我们全部或部分业务和/或资产和/或UNTONE TECHNOLOGY CO., LIMITED权益的任何实际或建议受让人。</li>
</ul>
<p>&nbsp;</p>
<p><strong><strong>17.责任限制</strong></strong></p>
<p><strong><strong>17.1赔偿责任</strong></strong></p>
<p>本条款及细则中的任何内容都不排除或限制任何一方当事人的责任，如果这样做是非法的。这包括一方当事人的以下责任：</p>
<ul>
<li>因其过失造成的死亡或人身伤害；</li>
<li>欺诈或欺诈性的虚假陈述；</li>
<li>根据本条款及细则，所有到期应付的款项。</li>
</ul>
<p><strong><strong>17.2直接损失</strong></strong></p>
<p>根据本条款及细则，直接损失可予赔偿。然而，除非本条款及细则中另有规定，任何一方都不对任何间接损失负责。</p>
<p><strong><strong>17.3不适用</strong></strong></p>
<p>我们将不对您承担以下责任：</p>
<ul>
<li>任何在我们直接控制范围之外的损失，这些损失是由任何第三方代理银行、流动性提供者或属于用于提供服务的支付网络的其他金融机构的疏忽、欺诈或故意不当行为或破产引起的。</li>
<li>如果您在您的指令中提供的任何信息是不正确的导致一笔付款未执行或有缺陷的执行；</li>
<li>如果收款人/收款银行未能正确处理付款，则由收款人/收款银行引起的错误、失误或不履行义务。</li>
</ul>
<p>在(b)或(c)的情况下，我们将做出合理的努力来追回支付所涉及的资金。</p>
<p><strong><strong>17.4累积责任</strong></strong></p>
<p>除第17.5条规定外，UNTONE TECHNOLOGY CO., LIMITED就本条款及细则引起的或与本条款有关的所有诉讼对您所承担的总责任不超过责任发生之前的一（1）年内您向UNTONE TECHNOLOGY CO., LIMITED支付的服务费总额。</p>
<p><strong><strong>17.5外汇兑换的责任</strong></strong></p>
<p>在适用法律允许的最大范围内，UNTONE TECHNOLOGY CO., LIMITED对外汇兑换的最大责任，无论是否因合同、侵权行为或其他原因引起，在任何情况下都不会超过UNTONE TECHNOLOGY CO., LIMITED在该外汇兑换中出售的货币金额。</p>
<p><strong><strong>17.6公平救济</strong></strong></p>
<p>单纯的损害赔偿可能不是对违约行为的充分补救，因此，任何一方都有权对任何可能或实际的违约行为寻求禁止令、具体履行或其他公平救济等补救措施。</p>
<p><strong><strong>17.7减轻损失</strong></strong></p>
<p>各方同意作出合理的努力，以减轻根据本条款及细则应予赔偿的任何损失。</p>
<p>&nbsp;</p>
<p><strong><strong>18.赔偿</strong></strong></p>
<p><strong><strong>18.1客户的赔偿</strong></strong></p>
<p>应要求，您将赔偿我们因以下原因而招致或遭受的所有损失、损害、费用（包括合理的法律费用）和开支：</p>
<ul>
<li>您违反本条款及细则、未遵守适用法律、未遵守可接受使用政策、或您使用或滥用我们的服务；</li>
<li>第三方声称我们在本条款及细则允许的范围内使用客户数据侵犯了任何知识产权；</li>
<li>您的任何付款或外汇兑换，包括我们按您的任何指示行事，而我们有理由相信该等指示是由您或您的授权用户作出的；</li>
<li>在兑换日或付款日之前关闭或取消全部或部分外汇兑换或付款，包括因您未能为外汇兑换或付款提供资金而我们不得不这样做的情况。</li>
</ul>
<p><strong><strong>18.2第三方索赔</strong></strong></p>
<p>第18.2条、第18.3条和第18.4条适用于第18条和第22条的义务。如果一方意识到有任何可能导致根据第18条或第22条提出索赔的索赔或诉讼（各自称为"第三方索赔"），该方将立即以书面形式通知另一方，在另一方始终遵守第18.3条的前提下，第一方将：</p>
<ul>
<li>允许另一方控制对此类第三方索赔的辩护；</li>
<li>应另一方的要求和提供支出，为另一方提供合理的援助，以维护任何此类第三方索赔。</li>
</ul>
<p><strong><strong>18.3辩护</strong></strong></p>
<p>如果对方承担第三方索赔的抗辩，对方将：</p>
<ul>
<li>迅速通知第一方当事人，它已经承担了这种辩护；</li>
<li>在任何时候都要考虑到第一方的利益和声誉，并遵守所有适用的法院规则，为此类第三方索赔进行辩护；</li>
<li>就任何谈判、和解或诉讼与第一方协商，并随时向其通报；</li>
<li>未经第一方事先书面同意，不得就第三方索赔达成任何涉及支付金钱以外的补救措施的和解或妥协。</li>
</ul>
<p><strong><strong>18.4赔偿</strong></strong></p>
<p>如果另一方在接到第三方索赔的书面通知后14天内没有根据第18.3条承担第三方索赔的辩护，则第一方或第一方指定的人可以其认为合适的方式为第三方索赔辩护，另一方将应要求赔偿相对方因该第三方索赔而产生的合理费用。</p>
<p><strong><strong>18.5赔偿条件</strong></strong></p>
<p>只有在以下情况下，本条款第18条规定的义务才适用：</p>
<ul>
<li>被赔偿方在得知或收到索赔后三十（30）天内以书面形式通知赔偿方；</li>
<li>被赔偿方，在费用由赔偿方承担的情况下，向赔偿方提供赔偿方所要求的合理协助，用于任何索赔的辩护和和解（如适用）；以及</li>
<li>被赔偿方向赔偿方提供控制和解决任何索赔的专属权利和权力。</li>
</ul>
<p>&nbsp;</p>
<p><strong><strong>19.协议终止和中止</strong></strong></p>
<p><strong><strong>19.1关闭您的账户</strong></strong></p>
<p>您可以通过停止使用服务的方式关闭您的UNTONE TECHNOLOGY CO., LIMITED账户，并在任何时候提前30个日历日以书面形式通知我们终止本条款及细则。</p>
<p><strong><strong>19.2</strong></strong><strong><strong>&nbsp;</strong></strong><strong><strong>有权中止或终止</strong></strong></p>
<p>我们可以随时通过书面通知您提前60个日历日终止本条款及细则（或任何其他条款）。此外，在下列情况下，我们可在不发出通知的情况下，立即暂停或终止全部或部分条款、任何附加条款或任何服务，或阻截任何交易。</p>
<ul>
<li>我们怀疑与您的UNTONE TECHNOLOGY CO., LIMITED账户有关的犯罪活动，怀疑您的UNTONE TECHNOLOGY CO., LIMITED账户被欺诈性使用，或我们有理由相信您曾因未经授权的交易而欺诈性地要求退款；</li>
<li>我们有理由相信您违反了适用法律；</li>
<li>我们在法律上需要这样做，包括按照任何相关监管机构的指示；</li>
<li>您违反了本条款及细则中的任何规定或违反了可接受使用政策中的任何适用限制或约束；</li>
<li>您向我们提供了虚假或不准确的信息，或者我们无法核实您提供的任何信息；</li>
<li>您通知我们，或者我们怀疑或识别任何可疑或实际的未经授权的交易；</li>
<li>您已被列入任何国家或国际限制或禁止的名单中，从而使我们无法与您开展业务；</li>
<li>您曾辱骂UNTONE TECHNOLOGY CO., LIMITED的任何人；</li>
<li>您没有接受对条款及细则的变更；</li>
<li>我们因技术或安全等原因暂停或停止全部或部分服务；</li>
<li>我们对您的UNTONE TECHNOLOGY CO., LIMITED账户，包括对服务的使用有合理的担忧；</li>
<li>您未在到期日之前支付或偿还欠我方的任何款项；</li>
<li>我们的银行合作伙伴之一，或提供服务所需的其他服务提供商要求我们终止本条款及细则；</li>
<li>您未使用UNTONE TECHNOLOGY CO., LIMITED帐户达12个月，该帐户便失效；</li>
<li>如果UNTONE TECHNOLOGY CO., LIMITED根据自己的决定认为客户为任何非法、破坏性或未经授权的目的利用商户服务平台，可以在提前一天通知客户的情况下暂停或终止客户对商户服务平台的访问。此外，如果发生以下任何一种情况，UNTONE TECHNOLOGY CO., LIMITED将保留终止服务的权利：</li>
<li>商户服务平台的全部或部分故障，包括构成商户服务平台的技术故 障；</li>
<li>商户服务平台的安全性受到破坏；</li>
<li>客户严重违反本协议规定的支付义务；或</li>
<li>为了遵守适用法律。</li>
<li>UNTONE TECHNOLOGY CO., LIMITED根据第2条采取的任何行为应在UNTONE TECHNOLOGY CO., LIMITED自行决定的必要时间内继续进行。</li>
</ul>
<p><strong><strong>19.3在可能的情况下，我们会向您发出暂停通知</strong></strong></p>
<p>我们会尽快向您发出任何暂停的通知以及暂停的原因，无论是在实施暂停之前，还是在暂停之后立即通知您，除非这样做会损害我们合理的安全措施或在其他方面是非法的。我们将在暂停的原因不复存在后，在切实可行的情况下尽快解除对服务的暂停。</p>
<p><strong><strong>19.4立即终止</strong></strong></p>
<p>在不影响任何其他权利或补救措施的情况下，任何一方均可在书面通知对方后立即终止本条款及细则或任何附加条款，且无需对对方承担任何责任。</p>
<ul>
<li>如果对方:</li>
<li>严重违反本条款及细则（或附加条款），并且如在能够补救的情况下，未能在收到正式书面通知后30天内补救该违约行为；</li>
<li>一系列违反本条款及细则（或附加条款）的行为，这些行为加在一起会产生影响或效果，或以其他方式构成重大违约；</li>
<li>成为破产事件的主体。</li>
<li>如果一方合理地确定履行其在本条款及细则下的义务已变得不合法；或发生不可抗力事件，导致另一方无法履行其在本条款及细则下的任何义务，时间超过1个月。</li>
</ul>
<p><strong><strong>19.5终止时的还款</strong></strong></p>
<p>终止时，您需要在30个自然日内偿还您欠我们的款项。在第19.2或19.4条规定的情况下，我们可能会向您收取我们产生的合理成本、费用和损失（包括因外汇差额或我们为弥补或减少风险而采取的任何行动而产生的费用）。我们会根据您的要求退还您在账户中的所有款项。</p>
<p><strong><strong>19.6终止的效力</strong></strong></p>
<p>在本条款及细则或任何附加条款终止时：</p>
<ul>
<li>您将无法使用UNTONE TECHNOLOGY CO., LIMITED平台（或该等附加条款下的服务），而根据本条款及细则或附加条款授予您的所有权利将被终止。</li>
<li>您必须立即归还或删除构成或关于UNTONE TECHNOLOGY CO., LIMITED平台（或该等附加条款下的服务）的属于UNTONE TECHNOLOGY CO., LIMITED的文件、笔记和其他材料的副本。</li>
<li>您在本条款及细则（或附加条款）下提供的服务至终止生效日的所有付款义务将立即到期并应当在60个自然日内支付。</li>
<li>各方将在本条款及细则或附加条款 终止后30天内归还或删除其掌握的另一方的所有保密信息，并且不会制作或保留该等保密信息的任何副本，除非为遵守适用法律而有必要；</li>
<li>任何明示或暗示在终止后具有效力的条款将继续具有完全的效力和作用。</li>
</ul>
<p><strong><strong>19.3</strong></strong><strong><strong>终止的其他理由</strong></strong></p>
<p>UNTONE TECHNOLOGY CO., LIMITED可以在下列情况之一，在任何时候暂停服务并终止本协议，而无需事先通知：</p>
<ul>
<li>如果金融监管机构、监管机构或执法机构对客户发出警告或向UNTONE TECHNOLOGY CO., LIMITED发出要求其停止服务的通知；</li>
<li>任何政府、监管或司法机构指示UNTONE TECHNOLOGY CO., LIMITED暂停或终止本协议；</li>
<li>客户被列入联合国或其他国际机构发布的限制或禁止名单；或根据UNTONE TECHNOLOGY CO., LIMITED经营所在国家的法律或法规，禁止UNTONE TECHNOLOGY CO., LIMITED与客户开展任何业务；</li>
<li>UNTONE TECHNOLOGY CO., LIMITED的银行合作伙伴要求UNTONE TECHNOLOGY CO., LIMITED终止本协议；或</li>
<li>UNTONE TECHNOLOGY CO., LIMITED自行判断认为客户从事虚假交易、欺诈、洗钱、卖淫、贩毒、恐怖融资或任何其他违反UNTONE TECHNOLOGY CO., LIMITED经营业务的司法管辖区的适用法律或法规的活动。</li>
</ul>
<p>&nbsp;</p>
<p><strong><strong>20.第三方服务供应商</strong></strong></p>
<p><strong><strong>20.1确认</strong></strong></p>
<p>您承认并同意：</p>
<ul>
<li>我们可能与第三方（包括UNTONE TECHNOLOGY CO., LIMITED集团的其他公司）合作提供服务；</li>
<li>如果您收到我们提供的有关第三方的信息，或由该等第三方提供的信息，您不会依赖该等信息，也不会就因依赖该等信息向我们或第三方提出任何索赔。您同意，如果您选择在违反本条款的情况下依赖该等信息，您将承担所有风险和责任。</li>
<li>对于客户通过UNTONE TECHNOLOGY CO., LIMITED平台进行的任何交易，UNTONE TECHNOLOGY CO., LIMITED不承担任何责任，也不作其他保证。</li>
<li>客户使用的某些软件和设备可能无法支持UNTONE TECHNOLOGY CO., LIMITED平台的某些功能。</li>
<li>客户须对因以下原因而导致的所有费用、损害赔偿、损失、罚款及UNTONE TECHNOLOGY CO., LIMITED的责任负责：</li>
<li>(如适用)客户的错误指示、超额支付、支付错误或客户造成的其他无效支付；</li>
<li>客户、客户的雇员、董事、高级职员、客户代表或任何代表客户的人的任何错误、或违约、疏忽、不当行为或欺诈；以及</li>
<li>客户未能遵守本协议和本服务附表的条款而导致的任何费用、损害赔偿、损失、罚款和责任。</li>
<li>对于因外汇交易的延迟、取消或失败而导致的服务汇率波动所造成的任何损失，UNTONE TECHNOLOGY CO., LIMITED不承担任何责任。</li>
<li>UNTONE TECHNOLOGY CO., LIMITED有权在任何时候撤销、扣留或暂停向客户提供服务。</li>
</ul>
<p><strong><strong>20.2服务由</strong></strong><strong><strong>UNTONE TECHNOLOGY CO., LIMITED</strong></strong><strong><strong>提供</strong></strong></p>
<p>如果我们使用第三方提供服务，则您承认服务是由UNTONE TECHNOLOGY CO., LIMITED向您提供的，您的合同关系的相对方依然是UNTONE TECHNOLOGY CO., LIMITED，除非关于使用服务或服务功能的任何附加条款另有书面规定。</p>
<p><strong><strong>20.3遵守数据保护法</strong></strong></p>
<p>如果我们使用第三方提供服务，我们将确保该第三方遵守与根据本条款及细则处理个人数据有关的数据保护法规。</p>
<p>&nbsp;</p>
<p><strong><strong>21.声明与保证</strong></strong></p>
<p><strong><strong>21.1客户保证</strong></strong></p>
<p>您向我们声明并保证，您：</p>
<ul>
<li>您在使用服务、UNTONE TECHNOLOGY CO., LIMITED平台和客户数据时，将遵守本条款及细则和所有适用法律。</li>
<li>有权利、权力和授权签订本条款及细则，并根据本条款及细则履行您的所有义务。</li>
<li>在不违反任何适用法律或任何第三方的所有权的情况下，有权向我们授予本条款及细则中定义的权利。</li>
<li>根据本条款及细则的第4条，将及时向我们提供准确、最新和完整的客户尽职调查信息和数据；</li>
<li>本服务和UNTONE TECHNOLOGY CO., LIMITED平台仅用于合法目的。</li>
</ul>
<p><strong><strong>21.2客户行为</strong></strong></p>
<p>您对服务及UNTONE TECHNOLOGY CO., LIMITED平台其他功能的任何使用，包括您本人或您允许访问UNTONE TECHNOLOGY CO., LIMITED平台的任何授权用户通过UNTONE TECHNOLOGY CO., LIMITED平台执行的任何数据或传输的内容，须负全责。您将尽一切合理的努力，确保没有未经授权的人会或可以接触您的UNTONE TECHNOLOGY CO., LIMITED账户或UNTONE TECHNOLOGY CO., LIMITED平台的其他功能。您不得干扰、破坏或对UNTONE TECHNOLOGY CO., LIMITED平台或服务的其他用户造成任何损害。</p>
<p><strong><strong>21.3您不能滥用</strong></strong><strong><strong>UNTONE TECHNOLOGY CO., LIMITED</strong></strong><strong><strong>平台</strong></strong></p>
<p>您不能：</p>
<ul>
<li>使用UNTONE TECHNOLOGY CO., LIMITEDAPIs或商户服务平台以外的方法访问UNTONE TECHNOLOGY CO., LIMITED平台，例如，未经我们允许，您不能使用自动化手段。</li>
<li>做任何可能破坏、禁用、过载或损害UNTONE TECHNOLOGY CO., LIMITED平台的行为，如服务攻击；</li>
<li>导致病毒或其他恶意代码干扰UNTONE TECHNOLOGY CO., LIMITED平台的使用。</li>
</ul>
<p><strong><strong>21.4免责声明</strong></strong></p>
<p>除本条款及细则中明确规定外，所有的保证、条件和条款，无论是立法、普通法或其他法律所明示或暗示的（包括任何关于质量满意或适用于某一特定目的或不侵权的暗示保证），均在法律允许的范围内排除。特别是，我们：</p>
<ul>
<li>对于UNTONE TECHNOLOGY CO., LIMITED平台的内容或数据、UNTONE TECHNOLOGY CO., LIMITED平台的特定功能或其准确性、可靠性、可用性或满足您需要的能力，不作任何承诺；</li>
<li>不保证UNTONE TECHNOLOGY CO., LIMITED平台将不间断或无错误地运行，将始终可用，其包含的信息是最新的或最新的，它将没有错误或病毒，或永远不会出现故障；</li>
<li>出于操作、安全或其他合理的原因，我们可能会偶尔中断您对UNTONE TECHNOLOGY CO., LIMITED平台的使用。在这种情况下，我们会在可行的情况下尽快恢复访问。</li>
</ul>
<p><strong><strong>21.5财务建议</strong></strong></p>
<p>您不得将UNTONE TECHNOLOGY CO., LIMITED提供的任何信息或评论视为财务建议。您应考虑就任何该等信息或意见及使用服务寻求您自己的独立建议。</p>
<p><strong><strong>21.6客户责任</strong></strong></p>
<p>客户：</p>
<ul>
<li>对通过商户服务平台传输的客户数据的质量、准确性和完整性负全部责任；</li>
<li>必须提供和/或获得使用商户服务平台所需的任何设备或电信线路和连接；</li>
<li>在UNTONE TECHNOLOGY CO., LIMITED提出要求后的两（2）个工作日内，必须向UNTONE TECHNOLOGY CO., LIMITED提供UNTONE TECHNOLOGY CO., LIMITED要求的有关付款的任何额外信息。</li>
</ul>
<p><strong><strong>21.7电子身份检查</strong></strong></p>
<ul>
<li>客户承认并同意，UNTONE TECHNOLOGY CO., LIMITED将获准进行电子数据库搜索和查询信用参考机构，以核实客户或其任何股东的身份和信用状况，以及是否符合所有&ldquo;了解您的客户&rdquo;（"KYC"）要求和UNTONE TECHNOLOGY CO., LIMITED经营所在司法管辖区的任何反洗钱/反恐融资法律（"AML/CTF"）。客户承认，在处理任何交易和执行任何服务之前，必须满足所有KYC要求。UNTONE TECHNOLOGY CO., LIMITED可以根据所有现行的和适用法律或其他要求，保存此类搜索的内容和结果的记录。</li>
<li>客户进一步承认并同意，UNTONE TECHNOLOGY CO., LIMITED被允许根据相关的反洗钱/反恐金融法对付款人和收款人进行必要的KYC筛选和交易监控。</li>
</ul>
<p><strong><strong>21.8与反洗钱/反恐金融法律有关的资金处理。</strong></strong></p>
<p>如果第21.8条规定的电子身份检查触发UNTONE TECHNOLOGY CO., LIMITED通知监管机构的义务，UNTONE TECHNOLOGY CO., LIMITED保留扣留、拒绝或延迟任何客户资金的外汇交易或付款的权利，以遵守UNTONE TECHNOLOGY CO., LIMITED经营所在司法管辖区的相关反洗钱/反恐金融法律的要求。</p>
<p>&nbsp;</p>
<p><strong><strong>22.市场动荡、错误和不可抗力</strong></strong></p>
<p><strong><strong>22.1不可抗力</strong></strong></p>
<p>只要不可抗力事件阻碍了任何义务的履行，双方均不对未能履行义务负责。发生不可抗力事件的一方将：</p>
<ul>
<li>迅速通知对方可能导致其无法履行义务的任何情况；</li>
<li>作出合理的努力，减轻不可抗力事件对其履行义务的影响。</li>
</ul>
<p><strong><strong>22.2市场中断</strong></strong></p>
<p>如果我们合理地认为，在我们向您提供外汇汇率后发生了市场中断，受市场中断影响的所有或某些货币被市场中断影响，在我们合理地确定市场中断期间已经结束之前，我们可能会修改任何外汇汇率，或任何外汇汇率的任何比率或利差部分，并立即生效。</p>
<p><strong><strong>22.3外汇汇率的错误</strong></strong></p>
<p>如果外汇兑换执行的外汇汇率明显且严重偏离市场价格，您明白您不得依赖该明显错误。在这种情况下，我们可能会宣布外汇兑换不具约束力，您需要向我们返还根据外汇兑换进行的任何金额，我们将以正确的汇率重新处理该外汇兑换。</p>
<p><strong><strong>22.4费用支付</strong></strong></p>
<p>本条款不限制或以其他方式影响您根据本条款及细则支付任何费用或其他收费或应付款项的义务。</p>
<p><strong><strong>23.一般条款</strong></strong></p>
<p><strong><strong>23.1完整协议</strong></strong></p>
<p>本条款及细则代表了双方之间的完整协议，并取代和取消了我们之间与之有关的协议、陈述、承诺和声明，无论是书面的还是口头的。每一方承认，在签订本条款及细则时，它并不依赖，也不会对本条款及细则中没有列出的任何陈述或保证（无论是无意还是疏忽）采取任何补救措施。各方同意，不得因本条款及细则中的任何陈述而对无意或疏忽的失实陈述或疏忽的错误声明提出索赔。</p>
<p><strong><strong>23.2投诉</strong></strong></p>
<p>如果我们犯了错误，或者您觉得我们在提供服务时没有达到您的期望，请让我们知道。我们有内部程序以便根据我们的监管要求公平和及时地处理投诉。我们的投诉程序副本可应要求提供。</p>
<p><strong><strong>23.3通知</strong></strong></p>
<p>本条款规定或允许的所有通知、要求和其他通信将以书面形式按双方的注册地址发给双方，并通过以下方式发送：</p>
<ul>
<li>挂号信或经认证的一等信；</li>
<li>快递或隔夜快递服务或亲自送达；</li>
<li>电子邮件。</li>
</ul>
<p>您同意并认可通过电子邮件和其他电子方式（如通过UNTONE TECHNOLOGY CO., LIMITED平台）接收我们的通知和其他通讯。</p>
<p><strong><strong>23.4关系</strong></strong></p>
<p>除本条款或任何附加条款中明确规定外，本条款中的任何内容均不得解释为在双方之间建立伙伴关系或合资企业，不得构成任何一方为另一方的代理人，也不得授权任何一方为另一方或代表另一方作出任何承诺。各方确认其是代表自己而非为任何其他人的利益行事。</p>
<p><strong><strong>23.5转让</strong></strong></p>
<p>未经对方事先书面同意，任何一方不得转让本条款及细则的全部或部分内容。任何试图这样做的行为将是无效的，并构成对本条款及细则的实质性违反。</p>
<p><strong><strong>23.6放弃</strong></strong></p>
<p>一方未能或延迟行使本条款及细则或法律规定的任何权利或补救措施，或单一或部分行使此类权利或补救措施，均不构成对该权利或任何其他权利或补救措施的放弃，也不排除或限制该权利或任何其他权利或补救措施的进一步行使。</p>
<p><strong><strong>23.7可分割性</strong></strong></p>
<p>如果本条款及细则的任何规定被任何有管辖权的法院确定为无效、不可执行或非法，则该规定将被视为已被删除，而不影响其余规定。如果该条款的某些部分被修改或删除后仍是有效、可执行和合法的，则该条款将以使其合法、有效和可执行所需的最小修改来适用。</p>
<p><strong><strong>23.8不招揽</strong></strong></p>
<p>在本条款及细则有效期间以及在终止后的一（1）年内，一方（"第一方"）不得在此前十八（18）个月内向与第一方有任何实质性交易的另一方（"第二方"）的任何工作人员索取服务。然而，为免生疑问，本条款不适用于：</p>
<p>(i) 第一方已事先征得第二方的书面同意；或</p>
<p>(ii) 由第一方或代表第一方进行的任何公开招聘活动，而不是专门针对第二方的任何工作人员。本条款第 24.8 条在本条款及细则终止后仍然有效。</p>
<p><strong><strong>23.9第三方权利</strong></strong></p>
<p>本条款及细则是在双方之间专门为双方的利益而订立的，《合约（第三方权利）条例》（第623章）的规定不适用于本条款。任何不是本条款及细则的一方的人（无论该人是否在本条款及细则中被点名、提及或以其他方式被识别，或是否属于在本条款及细则中被点名、提及或被识别的一类人的一部分）均无权根据任何适用法律（包括《合约（第三方权利）条例》）或以其他方式执行本条款及细则或享受本条款及细则的任何条款的利益。任何一方均不得为了任何第三方的利益而宣布自己是本协议下权利的受托人。</p>
<p><strong><strong>23.10支付顺序</strong></strong></p>
<p>我们可在符合法律规定的前提下，决定我们处理您账户的交易顺序。例如，如果您向我们提供了一个或多个付款指令，但没有向备付金银行账户支付足够的资金，除非我们接受您的其他指示，否则我们可以自主决定使用我们随后收集或收到的任何资金用于一个或多个付款指令的目的。</p>
<p><strong><strong>23.11记录</strong></strong></p>
<p>您同意，除明显错误的情况外，我们对您使用服务和通过UNTONE TECHNOLOGY CO., LIMITED平台进行的交易的记录是其内容的最终证据。</p>
<p><strong><strong>23.12本</strong></strong><strong><strong>条款及细则</strong></strong><strong><strong>原件一式两份，每方执一份，每份具有同等法律效力。</strong></strong></p>
<p><strong><strong>23.13适用法律</strong></strong></p>
<p>本条款及细则受香港法律管辖，并按香港法律解释。因本合同引起的或与本合同有关的任何争议、争议、差异或索赔，包括本合同的存在、有效性、解释、履行、本协议的违反或终止，或因本协议而产生的或与之有关的非契约性义务的任何争议，均应提交香港国际仲裁中心（&ldquo;HKIAC&rdquo;）根据提交仲裁通知时有效的香港国际仲裁中心管理的仲裁规则进行仲裁，并最终解决。仲裁地为香港。仲裁员人数应为一人，仲裁程序应以英文进行。</p>
<p><strong><strong>23.14副本</strong></strong></p>
<p>本协议可以通过纸质或电子形式签署并且可以签署两份副本，每一份合同都被视为原件并且是相同合同。如果本合同以在线形式签署，点击&ldquo;我确认&rdquo;或类似按钮，注册、访问或使用服务（统称为&ldquo;表示同意&rdquo;），即表示您与UNTONE TECHNOLOGY CO., LIMITED达成了具有法律约束力的协议并且您同意接受本协议的条款和规则。在您作出表示同意的情形，您和UNTONE TECHNOLOGY CO., LIMITED同意签署本协议的纸质版，则本协议的纸质版也是有效的，并可追溯至您首次作出指示同意之日起生效。如果本协议的在线版本和纸质形式之间存在不一致的情况，则以在线版本为准。</p>
<p>&nbsp;</p>
<p><strong><strong>24.定义和解释</strong></strong></p>
<p><strong><strong>24.1在这些术语中，适用以下定义：</strong></strong></p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>账户</strong></strong><strong><strong>&rdquo;</strong></strong>是指记录您业务细节的电子信息资料，用于登录和使用UNTONE TECHNOLOGY CO., LIMITED平台。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>诉讼</strong></strong><strong><strong>&rdquo;</strong></strong>是指就任何性质的损失、损害、成本、罚款、费用和其他责任（无论是可预见的还是可能发生的，也无论是否与第三方索赔有关），包括与任何违约、疏忽、欺诈、故意不当行为、违反法定义务或其他索赔相关的，无论如何遭受、发生或持续的任何诉讼、索赔、要求或程序。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>附加条款</strong></strong><strong><strong>&rdquo;</strong></strong>是指适用于使用我们的服务的任何附加使用条款，可在我们的网站或通过其他UNTONE TECHNOLOGY CO., LIMITED指定的形式获取，包括适用于在特定地区使用我们的服务的任何特定条款。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>API</strong></strong><strong><strong>&rdquo;</strong></strong>是指技术接口，列明客户技术系统与UNTONE TECHNOLOGY CO., LIMITED平台整合所需的协议和规格，以便授权用户使用服务。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>API文件</strong></strong><strong><strong>&rdquo;</strong></strong>是指可在我们的网站或通过其他UNTONE TECHNOLOGY CO., LIMITED指定的形式获取的，适用于UNTONE TECHNOLOGY CO., LIMITEDAPI的文件和指南。</p>
<p>&ldquo;适用法律&rdquo;是指所有适用于任何一方本条款及细则项下所进行的或实现的活动的法律、法规、规章、具有约束力的行为准则或任何相关监管机构的规则或要求，包括与以下方面有关的法律、法规、规章、具有约束力的行为准则或任何相关监管机构的规则或要求：</p>
<p>(i)&nbsp;货币服务业务；</p>
<p>(ii)&nbsp;支付服务；</p>
<p>(iii)&nbsp;反洗钱、了解你的客户、打击恐怖主义融资和制裁要求；</p>
<p>(iv)&nbsp;数据保护；</p>
<p>(v)&nbsp;消费者保护；</p>
<p>(vi)&nbsp;任何监管机构发布的、香港知名金融机构须遵守或惯常遵守的任何实务守则或指引。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>授权用户</strong></strong><strong><strong>&rdquo;</strong></strong>是指您为第7.1条规定的目的而指定的任何人员（例如，您的任何董事、高级职员、雇员 或专业顾问）。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>订单确认</strong></strong><strong><strong>&rdquo;</strong></strong>是指UNTONE TECHNOLOGY CO., LIMITED对通过UNTONE TECHNOLOGY CO., LIMITED平台提出的外币兑换客户请求的回应和确认。</p>
<p>&ldquo;买入货币&rdquo;是指客户通过UNTONE TECHNOLOGY CO., LIMITED的入口从UNTONE TECHNOLOGY CO., LIMITED购买的一种支持货币，作为客户请求的一部分。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>工作日</strong></strong><strong><strong>&rdquo;</strong></strong>是指香港银行通常开门工作日（不包括星期六、星期日或香港的公众假期，或香港悬挂八号或以上台风信号或黑色暴雨预警的任何一天）及/或在账户司法管辖区，账户司法管辖区的支付基础设施在该日开放并且银行进行日常业务活动的日历日（星期六、星期日及公众假期除外）。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>收款服务</strong></strong><strong><strong>&rdquo;</strong></strong>是指UNTONE TECHNOLOGY CO., LIMITED根据本条款及细则向您提供的与UNTONE TECHNOLOGY CO., LIMITED以支持货币收款有关的收款代理服务。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>保密信息</strong></strong><strong><strong>&rdquo;</strong></strong>是指并包括所有口头或书面的保密信息：</p>
<ul>
<li>一方从另一方获得或收到的关于一方业务和事务的信息；</li>
<li>因履行本条款及细则规定的任何义务而产生的信息。</li>
</ul>
<p>保密信息不包括以下信息：</p>
<ul>
<li>接收方在收到披露方的信息之前已经知道，且在披露方面不受限制；</li>
<li>从合法获得信息的第三方处收到，且该第三方没有义务限制其披露；</li>
<li>披露方以书面形式批准解除本条款的约束；</li>
<li>可在公共领域获得且不违反本条款及细则的信息；</li>
<li>在没有获得披露方披露的任何保密信息的情况下独立开发的信息。</li>
</ul>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>确认</strong></strong><strong><strong>&rdquo;</strong></strong>是指UNTONE TECHNOLOGY CO., LIMITED对您向我们发出的外汇兑换、支付或两者的指令的回应和确认。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>兑换日</strong></strong><strong><strong>&rdquo;</strong></strong>是指在外汇兑换中买入的资金以清算资金提供给客户的日期。双方选择进行交易的任何货币对的兑换日必须是两国的工作日（即双方进行交易的国家）。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>备付金银行账户</strong></strong><strong><strong>&rdquo;</strong></strong>是指以UNTONE TECHNOLOGY CO., LIMITED名义开设的银行账户，您可以将资金汇入该账户用以任何外汇兑换或支付交易。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>客户数据</strong></strong><strong><strong>&rdquo;</strong></strong>是指描述您的业务及其运营、您的产品或服务以及您的客户所下订单的信息。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>客户保证金</strong></strong><strong><strong>&rdquo;</strong></strong>是指适用于您的于UNTONE TECHNOLOGY CO., LIMITED平台指定的金额，或我们不时以书面形式通知您的任何其他百分比或金额。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>数据</strong></strong><strong><strong>&rdquo;</strong></strong>是指所有客户数据、个人数据、支付数据、UNTONE TECHNOLOGY CO., LIMITED数据、使用UNTONE TECHNOLOGY CO., LIMITED基础设施的交易详情、用于欺诈检测和分析的信息、与服务相关的汇总或匿名信息，以及由UNTONE TECHNOLOGY CO., LIMITED或服务创建或源自UNTONE TECHNOLOGY CO., LIMITED的任何其他信息。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>数据主体</strong></strong><strong><strong>&rdquo;</strong></strong>是指任何可直接或间接通过姓名、识别号码、位置数据等识别符，或通过个人的身体、生理、基因、心理、经济、文化或社会身份等特定因素而被识别的自然人。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>数据保护法规</strong></strong><strong><strong>&rdquo;</strong></strong>是指适用的隐私及数据保护法律，以及任何适用于香港的有关处理个人数据及电子通讯隐私的全国性执行法律、法规及委任立法，并经不时修订、取代或更新。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>直接损失</strong></strong><strong><strong>&rdquo;</strong></strong>是指，就任何违约而言，违约方知道，或处于违约方地位的一个理性人应该知道的损失：</p>
<p>(i)&nbsp;在订立本条款及细则时；或</p>
<p>(ii)&nbsp;在违约时，可能因违约而合理造成。</p>
<p>为避免疑问，即使违约方知道或应该知道有可能发生这种损失或损害，商誉、业务、利润、经营时间、声誉、机会，或数据或信息损坏的损失，或预期节约的损失均不属于直接损失。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>不可抗力事件</strong></strong><strong><strong>&rdquo;</strong></strong>是指超出一方合理控制范围的事件，包括：罢工、停工、严重的劳资冲突（但不包括该方雇员、代理人或分包商的罢工或其他形式的劳工行动）；公用事业服务(包括互联网、电力、煤气或水)的中断或故障；暴动、战争、大流行病或恐怖袭击；核污染、化学污染或生物污染；极端异常的天气状况；实施制裁、禁运或断绝外交关系；或适用法律的任何变化。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>外汇基准汇率</strong></strong><strong><strong>&rdquo;</strong></strong>是指我们在考虑了我们的外汇汇率服务提供商提供的成本、银行间汇率和相关市场条件后，为外汇兑换和兑换日指定的货币兑换基准汇率。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>外汇兑换</strong></strong><strong><strong>&rdquo;</strong></strong>是指双方通过UNTONE TECHNOLOGY CO., LIMITED平台按约定的汇率以一种货币出售或购买另一种货币的协议。</p>
<p>&ldquo;外汇兑换服务&rdquo;是指UNTONE TECHNOLOGY CO., LIMITED根据本条款及细则提供的有关外汇兑换的服务。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>外汇汇率</strong></strong><strong><strong>&rdquo;</strong></strong>是指外汇基本汇率加上可能适用于您的任何其他保证金，包括客户保证金。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>全球账户</strong></strong><strong><strong>&rdquo;</strong></strong>是指以您的名义注册的唯一分类账账户，作为收款服务的一部分，该账户记录了UNTONE TECHNOLOGY CO., LIMITED为您向付款人收取的资金数额。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>集团公司</strong></strong><strong><strong>&rdquo;</strong></strong>是指UNTONE TECHNOLOGY CO., LIMITED或UNTONE TECHNOLOGY CO., LIMITED的最终控股公司：</p>
<p>(i)&nbsp;直接或间接拥有超过百分之五十(50%)的投票权或已发行股本的任何实体；或</p>
<p>(ii)&nbsp;能够控制该实体的活动和业务按照其意愿进行香港是指中华人民共和国香港特别行政区。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>间接损失</strong></strong><strong><strong>&rdquo;</strong></strong><strong><strong>是指不属于直接损失的损失。</strong></strong></p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>破产事件</strong></strong><strong><strong>&rdquo;</strong></strong>是指：</p>
<p>(i)&nbsp;为清算或重组而启动的任何程序；</p>
<p>(ii)&nbsp;为就该方或其全部或实质上全部资产委任破产管理人、接管人、行政接管人或受托人而采取的任何步骤或启动的任何程序；</p>
<p>(iii)&nbsp;该方全部或绝大部分资产的任何担保的持有人采取任何步骤强制执行该等担保；</p>
<p>(iv)&nbsp;该方全部或绝大部分资产被扣押、查封、执行或任何类似程序；</p>
<p>(v)&nbsp;该方无力偿还其到期债务；</p>
<p>(vi)&nbsp;该方（不论是由该方的董事会或其他人）与其债权人或任何类别的债权人订立协议，包括公司自愿安排协议或安排契据；或</p>
<p>(vii)&nbsp;该方（不论是由该方董事会或其他人）根据任何司法管辖区的法律，订立或采取任何步骤，以进行任何类似于上文(i)至(vi)所述程序的程序，而在每一种情况下不包括该方与一家或多家其他公司的非破产合并计划或该方的非破产重组计划。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>知识产权</strong></strong><strong><strong>&rdquo;</strong></strong>是指：</p>
<p>(i)&nbsp;任何专利、注册外观设计、外观设计权、商标、商号（包括与任何商标或商业名称有关的商誉）、版权及相关权利、精神权利、数据库、域名、半导体和其他拓扑权和实用新型，以及包括对这些权利的注册和申请、续展或延长，以及在世界任何地方的类似或同等权利或保护形式的权利，以及与这些权利有关的权利；</p>
<p>(ii)&nbsp;不正当竞争权性质的权利，以及对假冒和过去的侵权行为提起诉讼的权利；以及</p>
<p>(iii)&nbsp;商业秘密和其他专有权利，包括专有技术和其他技术信息的权利。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>市场中断</strong></strong><strong><strong>&rdquo;</strong></strong>是指UNTONE TECHNOLOGY CO., LIMITED有权独自和完全决定的任何行动、事件或情况。</p>
<p>(i)&nbsp;直接或间接地阻碍、限制或制约了UNTONE TECHNOLOGY CO., LIMITED或其集团公司获得确定的报价、将任何货币兑换成任何其他货币、或将任何款项转移到任何其他国家或在同一国家内的能力；</p>
<p>(ii)&nbsp;导致银行间外汇市场无法按照正常的商业惯例提供任何购买货币；或(iii)构成外汇市场的异常价格波动。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>商户服务平台</strong></strong><strong><strong>&rdquo;</strong></strong>是指客户及其授权用户可用于访问UNTONE TECHNOLOGY CO., LIMITED平台和服务的用户界面。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>网络规则</strong></strong><strong><strong>&rdquo;</strong></strong>是指由运营UNTONE TECHNOLOGY CO., LIMITED支持的支付网络的金融服务提供商不时实施的指南、附则、规则、协议和条例（包括Visa、MasterCard或American&nbsp;Express的卡组织操作规则）。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>付款</strong></strong><strong><strong>&rdquo;</strong></strong>是指作为支付服务的一部分，UNTONE TECHNOLOGY CO., LIMITED通过UNTONE TECHNOLOGY CO., LIMITED平台为您向第三方收款人支付的每一笔款项。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>支付数据</strong></strong><strong><strong>&rdquo;</strong></strong>是指支付账户信息、与金融服务提供商传递或由金融服务提供商提供的信息、适用法律和网络规则特别规定的金融信息，以及使用我们的服务时产生的任何其他交易信息。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>付款日期</strong></strong><strong><strong>&rdquo;</strong></strong>是指您通过UNTONE TECHNOLOGY CO., LIMITED平台向我们发出的指令中指定的日期，以便将付款从UNTONE TECHNOLOGY CO., LIMITED转给收款人。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>付款服务</strong></strong><strong><strong>&rdquo;</strong></strong>是指，与UNTONE TECHNOLOGY CO., LIMITED根据您提供的支付指令以支持货币向收款人做出的任何付款相关，UNTONE TECHNOLOGY CO., LIMITED根据本条款及细则向您提供的支付代理服务。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>个人数据</strong></strong><strong><strong>&rdquo;</strong></strong>是指通过服务收集、传输或访问的可识别特定自然人（而非公司、法律实体或机器）的信息，数据保护法规另有规定的除外。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>平台</strong></strong><strong><strong>&rdquo;</strong></strong>是指由UNTONE TECHNOLOGY CO., LIMITED设计的专有技术和相关产品（包括但不限于在商户服务平台上和通过UNTONE TECHNOLOGY CO., LIMITEDAPI发现的专有技术和相关产品），以向客户提供服务，包括访问全球账户。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>监管机构</strong></strong><strong><strong>&rdquo;</strong></strong>是指与适用法律的制定、执行、监督或遵守有关的任何个人或监管机构，包括香港海关和任何取代香港海关的监管机构。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>受限人员</strong></strong><strong><strong>&rdquo;</strong></strong>是指下列人：</p>
<p>(i)&nbsp;被列入任何制裁名单，或被列入任何制裁名单的人所拥有或控制；</p>
<p>(ii)&nbsp;位于受全国性制裁的国家或地区，或根据该国家或地区的法律成立，或由位于该国家或地区或根据该国家或地区的法律组织的人所拥有或控制，或代表其行事；或</p>
<p>(iii)&nbsp;因其他原因而成为制裁对象。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>制裁</strong></strong><strong><strong>&rdquo;</strong></strong>是指由下列国家实施、制定或执行的任何经济制裁法律、法规、禁运或限制性措施:</p>
<p>(i)&nbsp;香港；</p>
<p>(ii)&nbsp;美国；</p>
<p>(iii) 联合国；</p>
<p>(iv) 欧盟；</p>
<p>(v)&nbsp;英国；</p>
<p>(vi)&nbsp;UNTONE TECHNOLOGY CO., LIMITED经营的任何其他司法管辖区；或</p>
<p>(vii)&nbsp;上述任何一项的各自政府机构和机构，包括但不限于美国财政部外国资产控制办公室(&ldquo;OFAC&rdquo;)、美国国务院和英国财政部(统称&ldquo;制裁当局&rdquo;)。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>制裁名单</strong></strong><strong><strong>&rdquo;</strong></strong>系指OFAC发布的特别指定国民和被冻结人员名单，英国财政部发布的金融制裁目标综合名单，或任何制裁机构发布、维护或公布的任何类似名单。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>卖出货币</strong></strong><strong><strong>&rdquo;</strong></strong>是指客户通过UNTONE TECHNOLOGY CO., LIMITED平台向UNTONE TECHNOLOGY CO., LIMITED出售的支持货币之一，作为客户请求的一部分。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>服务</strong></strong><strong><strong>&rdquo;</strong></strong>是指UNTONE TECHNOLOGY CO., LIMITED根据本条款及细则向客户提供的服务，包括通过UNTONE TECHNOLOGY CO., LIMITED平台提供的收款服务、外汇兑换服务和付款服务。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>服务费</strong></strong><strong><strong>&rdquo;</strong></strong>是指适用于使用每项服务的所有费用。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>结算截止日</strong></strong><strong><strong>&rdquo;</strong></strong>是指根据本条款及细则以清算资金向UNTONE TECHNOLOGY CO., LIMITED支付任何款项的时间和日期。一般来说，结算截止日为相关付款的付款日期之前的一个工作日。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>源</strong></strong><strong><strong>币种</strong></strong><strong><strong>&rdquo;</strong></strong>是指客户在客户请求中指定的一种支持币种，用于在UNTONE TECHNOLOGY CO., LIMITED平台上进行支付。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>即期交易</strong></strong><strong><strong>&rdquo;</strong></strong>是指双方按约定的汇率实时卖出或买入一种货币对另一种货币的交易，但该交易的结算时间应在结算截止日或之前（该时间可根据市场要求而改变，UNTONE TECHNOLOGY CO., LIMITED应至少提前5个工作日通知客户）。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>支持</strong></strong><strong><strong>币种</strong></strong><strong><strong>&rdquo;</strong></strong>是指，就服务的每项功能而言，UNTONE TECHNOLOGY CO., LIMITED不时允许的每一种货币，可以通过UNTONE TECHNOLOGY CO., LIMITED平台使用该功能收取、兑换和/或支付。</p>
<p><strong><strong>&ldquo;</strong></strong><strong><strong>用户资料</strong></strong><strong><strong>&rdquo;</strong></strong>是指，就每个授权用户而言，记录授权用户详细资料的电子信息资料，用于代表您登录和使用UNTONE TECHNOLOGY CO., LIMITED平台。</p>
<p><strong><strong>24</strong></strong><strong><strong>.</strong></strong><strong><strong>2除非上下文另有要求：</strong></strong></p>
<ul>
<li>单数的使用包括复数，反之亦然。</li>
<li>凡提及法规或法定条文，均指经不时修订的法律或是行政规章。</li>
<li>&ldquo;包括&rdquo;、&ldquo;特别是&rdquo;、&ldquo;例如&rdquo;或任何类似词汇所引入的任何短语将被解释为为说明性的，且不会限制该等词汇之前的词汇的意义。</li>
</ul>
<p><strong><strong>24.3凡提及各方时，均包括</strong></strong><strong><strong>本条款及细则</strong></strong><strong><strong>允许的任何继承人、获准受让人</strong></strong></p>
<p>提到的任何一方对任何人的任何费用、索赔或责任的赔偿包括对任何和所有责任、损失和费用的赔偿，以及（在最大范围内，但仅在适用法律允许的情况下）任何相关监管机构施加的任何民事或刑事罚款以及任何合理产生的法律费用、成本和开支。</p>
<p><strong><strong>24.4在本协议中，如果上下文允许：</strong></strong></p>
<ul>
<li>提及某项法定条文时，包括提及：</li>
</ul>
<p>(i)&nbsp;任何当时有效的命令、条例、法定文书或其他附属法例（无论何时制定）；</p>
<p>(ii)&nbsp;对其进行任何修改、修订、合并、重新制定或替换，或对其规定进行修改、修订、合并、重新制定或替换，但在本协议日期后进行的任何修改、修订、合并、重新制定或替换将增加本协议任何一方的责任的情况除外。</p>
<p>(b)&nbsp;凡提及条款、附表或段落，即分别指本协议的条款、附表或附表的段落或本协议的段落。</p>
<p>(c)&nbsp;提及本协议各方包括其各自的继承人、允许的受让人和个人代表。</p>
<p>(d)&nbsp;提及由多于一人组成的本协议任何缔约方时，包括构成该缔约方的每个人。</p>
<p>(e)&nbsp;任何性别的提法包括另一性别。</p>
<p>(f)&nbsp;对人的提及包括法人或非法人。</p>
<p>(g)&nbsp;对任何专业事务所或公司的提及，包括任何有效地继承其全部或实质上全部执业或业务的事务所或公司。</p>
<p>(h)&nbsp;由多人明示作出或订立的所有保证、陈述、协议和义务，均由有关人员共同和分别作出或订立。</p>
<p>(i)&nbsp;索引、标题和任何描述性说明仅为便于参考，不影响本协议的解释或诠释。</p>
<p>(j)&nbsp;就任何文件而言，"商定的格式"是指缔约方之间商定的、由缔约方或代表缔约方草签的、仅用于识别的格式。</p>
<p>(k)&nbsp;凡提及&ldquo;商定格式&rdquo;的文件，均指采用各方商定的格式并由各方草签的文件，以资识别。</p>
<p>(l)&nbsp;&ldquo;书面形式&rdquo;包括传真和电子邮件。</p>
<p>(m)&nbsp;本协议中对某人规定的不做某事的任何义务包括不同意或不允许做该事的义务。</p>
<p>(n)&nbsp;在文意允许的情况下，&ldquo;其他的&rdquo;和&ldquo;其他&rdquo;是说明性的，不应限制前面词语的含义。</p>
<p>(o)&nbsp;除文意另有所指外，提述&ldquo;一天&rdquo;的时间是指香港时间，而提述一天的时间是指由前一天午夜开始的24小时。</p>
      </div>
    </a-card>
  </div>
</template>

<script>
import { reactive, toRefs, inject } from 'vue'
import { useRouter } from 'vue-router'
export default {
  name: 'TermsOfServiceCN',
  setup () {
    const router = useRouter()
    const state = reactive({
      themeData: inject('$themeData')
    })

    const clauseSupplement = () => {
      const clauseSupplyUrl = router.resolve({ name: 'clauseSupply' })
      window.open(clauseSupplyUrl.href, '_blank')
    }

    const usePolicy = () => {
      const usePolicyUrl = router.resolve({ name: 'usePolicy' })
      window.open(usePolicyUrl.href, '_blank')
    }

    return {
      clauseSupplement,
      usePolicy,
      ...toRefs(state)
    }
  }
}
</script>

<style scoped>
p.detail{margin-top: 20px;}
p.navigationTitle{margin-top: 20px;font-size: 18px;color: black;font-weight: bold;}
span.detailTitle{font-size: 15px;color: black;font-weight: bold;margin-bottom: 10px}
span.use-two-title {margin-left: 20px;}
</style>

